{
  "settings": {
    "calendar": {
      "calendar_settings": "Indstillinger",
      "settings": "Indstillinger",
      "select_calendar_type": "Vælge Kalendertype",
      "add_new_calendar_group": "Tilføj ny Gruppe",
      "add_new_equipment": "Tilføj ny Udstyr",
      "new_calendar": "ny Kalender",
      "calendar_group_description": "Brug kalender Gruppe til effektivt at Sortere og Gruppe flere kalendere sammen.",
      "group": "Gruppe",
      "manage_your_calendars_and_groups": "Administrer dine kalendere og gruppe",
      "groups": "Grupper",
      "create_group": "Opret Gruppe",
      "create_calendar": "Opret kalender",
      "calendar_name": "Kalenderens navn",
      "group_duration": "Gruppe Varighed",
      "calendar_type": "Type",
      "action": "Handling",
      "round_robin": "Automatisk tildeling af aftaler",
      "event": "Begivenhed",
      "event_booking_alert_message": "Denne kalendertype har vigtige forskelle",
      "event_booking_alert_title": "Vigtigt",
      "event_booking_know_more": "Få mere at vide",
      "event_booking_tooltip_content": "• Dynamiske mødelinkværktøjer understøttes ikke (f.eks. Zoom/Google Meet/MS Teams)\n • Der kan ikke tildeles en bruger\n • Begivenheder synkroniseres som standard ikke med en brugers kalender\n • Kun én Google Kalender kan synkroniseres via ekstern synkronisering\n • Konfliktende kalendere understøttes ikke",
      "event_booking_tooltip_title": "Ting du skal vide:",
      "group_name": "Gruppenavn",
      "room_name": "Rum",
      "group_description": "Gruppe Beskrivelse",
      "calendar_url": "Kalender-URL",
      "calendars": "Kalendere",
      "date_updated": "Dato Opdateret",
      "status": "Status",
      "action_dropdown": "Rulleliste for Handling",
      "calendar_list": "Serviceydelser Medlemmer til",
      "edit": "Rediger",
      "duplicate": "Duplikere",
      "copy_embed_code": "Kopiér Indlejringskode",
      "copy_permanent_link": "Kopiér permanent Link",
      "copy_new_slug_link": "Kopiér Link til planlægning",
      "copy_scheduling_link": "Kopiér Link til planlægning (ældre forældet)",
      "deactivate_calendar": "Suspendere kalender",
      "move_to_group": "Flyt til Gruppe",
      "delete_calendar": "Slet kalender",
      "delete_group": "Slet",
      "delete_this_group": "Slet denne gruppe",
      "activate_calendar": "udløser Kalender",
      "duration": "Varighed",
      "all": "hver",
      "draft": "Kladde",
      "inactive": "Inaktiv",
      "active": "Dynamisk",
      "actions": "aktiviteter",
      "rearrange_calendars": "Ændre Kalendere",
      "deactivate_all_calendars_in_group": "Ophæng hver kalendere in gruppen",
      "activate_all_calendars_in_group": "udløser hver kalendere in Gruppe",
      "no_groups_found": "Din Søge matchede ikke nogen kalender Gruppe.",
      "no_groups_in_location": "Gruppe Sortere dine kalendere Synes godt om Mappe. Tilføj kalendere til en gruppe, og slet et individuelt Link til planlægning, så Booker vælge fra flere kalendere.",
      "no_calendars_found": "Kom i gang Via kalender Via Oprettet ny kalender.",
      "no_calendars_found_search": "Din Søge matchede ikke nogen kalendere.",
      "delete_calendar_message": "Du're Om at slette kalenderen. Når Du Visninger slette det vil også slette hver sin Aftale.",
      "delete_calendar_message_title": "Vil du slette denne kalender?",
      "duplicate_calendar_message": "Du're Om til Duplikere-kalender. Dette vil Opret en ny kalender med de samme Indstillinger som Valgt-kalenderen.",
      "duplicate_calendar_message_title": "Duplikere denne kalender?",
      "no_calendars_found_title": "Der blev ikke fundet nogen kalendere",
      "no_groups_in_location_title": "Ingen gruppe fundet",
      "delete_group_confirmation_title": "Vil du slette denne Gruppe?",
      "delete_group_confirmation": "Er du sikker på, at du ønsker at slette Valgt Gruppe?",
      "delete_group_confirmation_checkbox_title": "Slet Medlemmer kalendere og Aftale",
      "delete_group_confirmation_checkbox_description": "Hvis du vælger denne mulighed, slettes også kalenderne in denne gruppe sammen med hver Aftale in disse kalendere.",
      "group_status_message_title": "{status} Gruppe og hvert medlemmer-kalendere?",
      "calendar_status_message_title": "{status} denne kalender?",
      "calendar_status_message": "Du're Om til {status} kalender",
      "group_status_active_message": "Er du sikker på, at du vil udløse denne gruppe? hver kalendere i Gruppen vil også være Aktiveret og tilgængelige til booking",
      "group_status_inactive_message": "Er du sikker på, at du vil suspendere denne gruppe? Hver kalendere i Gruppen vil også være deaktiveret og tilgængelige for booking",
      "coming_soon": "Kommer snart",
      "select": "Vælge",
      "15mins": "15 minutter",
      "cancel": "Annuller",
      "save": "Arkiv",
      "create": "Opret",
      "select_calendar_group": "Vælge Gruppe",
      "move_calendar_confirmation": "Note , at det gamle Link vil stoppe med at fungere, når du Fortsæt med Rediger. Bekræft Via at vælge Afkrydsningsfelt.",
      "previously_called_unassigned": " (Tidligere kaldt som ikke tildelt)",
      "scheduling_type": "Vælge Kalendertype",
      "scheduling_type_description": "Vælg en Kalendertype for at konfigurere din kalender og Tilpas, hvor Aftale er Planlagt.",
      "service_menu_name": "Navn på servicemenu",
      "template": "Skabelon",
      "select_template": "Vælg skabelon",
      "group_url": "Gruppe URL",
      "template_description": "Du har valget mellem at vælge Eller de Klassisk Eller Neo -skabeloner til Gruppe Vis",
      "rooms": "Rum",
      "rooms_name": "Navn",
      "rooms_description": "Beskrivelse",
      "rooms_modal_description": "Tilføj Eller Rediger Rum",
      "rooms_capacity": "Sum kapacitet",
      "no_rooms_in_location_title": "Ingen rum fundet",
      "no_rooms_in_location": "Ingen rum fundet in denne placering",
      "no_equipments_in_location": "Intet Udstyr fundet in denne Placering",
      "equipments": "Udstyr",
      "equipment_name": "Navn",
      "equipment_name_search": "Udstyr",
      "equipment_description": "Beskrivelse",
      "equipment_modal_description": "Tilføj Eller Rediger an Udstyr",
      "add_equipment": "Tilføj/ Rediger Udstyr",
      "add_room": "Tilføj/ Rediger Rum",
      "equipment_quantity": "Sum mængde",
      "equipment_outOfService": "Fra Servicemængde",
      "no_equipments_in_location_title": "Intet Udstyr fundet",
      "delete_this_equipment": "Slet dette Udstyr",
      "delete_this_rooms": "Slet denne rom",
      "delete_equipment_confirmation": "Er du sikker på, at du vil slette dette Udstyr? Dette vil også være Slettet fra hver the Tredjepartskalendere.",
      "delete_rooms_confirmation": "Er du sikker på, at du vil slette denne rom? Dette vil også være Slettet fra hver the Tredjepartskalendere.",
      "add_new_calendar_equipments": "Tilføj nyt Udstyr",
      "no_equipments_found": "Din Søge matchede ikke noget Udstyr.",
      "no_rooms_found": "Din Søge matchede ikke nogen rom.",
      "add_new_calendar_rooms": "Tilføj ny Rum",
      "rooms_disable": "Deaktiver Rum",
      "equipments_disable": "Deaktiver Udstyr",
      "equipments_activate": "udløser Udstyr",
      "rooms_activate": "udløser Rum",
      "create_equipments": "Opret Udstyr",
      "create_rooms": "Opret Rum",
      "select_calendar_rooms_title": "Vælge kalender",
      "select_calendar_rooms_description": "Du kan Vælge flere kalendere til Tilknyttet enhed med Rum",
      "select_calendar_equipments_title": "Vælge kalender",
      "select_calendar_equipments_description": "Du kan vælge en kalender til Tilknyttet enheden med Udstyr",
      "disable_equipment_title": "{status} Udstyr",
      "disable_room_title": "{status} Rom",
      "equipments_status_message": "Er du sikker på, at du vil {status} dette Udstyr?",
      "rooms_status_message": "Er du sikker på, at du vil {status} denne rum?",
      "calendar_resource_disclaimer": "Dette kan påvirke Tilgægelselighed Til Medlemmer servicekalendere.",
      "equipment_disclaimer": "Note: Hvis du aktiverer Udstyr senere, vil du automatisk Opret forbindelse igen den til kalendere, den er Medlemmer med",
      "room_disclaimer": "Note: Hvis du aktiverer Rummet senere, vil du automatisk Opret forbindelse igen den til de kalendere, den er Medlemmer med",
      "equipment_tab_name": "Udstyr",
      "rooms_tab_name": "Rum",
      "manage_your_rooms": "Administrator Rum til din Virksomhed her",
      "manage_your_equipments": "Administrer Udstyr for din Virksomhed her",
      "select_service_calendar_description_equipments": "Du kan vælge flere servicekalendere til Tilknyttet enhed med Udstyr",
      "select_service_calendar_description_rooms": "Du kan Vælge flere servicekalendere til Tilknyttet enhed med Rum",
      "service_menus": "Servicemenu",
      "manage_your_calendars_groups_and_service_menus": "Administrer dine kalendere, gruppe og servicemenu",
      "new_service_menu": "Opret servicemenu",
      "deactivate_service_menu": "Suspendere servicemenu",
      "delete_service_menu": "Slet denne servicemenu",
      "delete_service_menu_confirmation": "Er du sikker på, at du vil slette denne servicemenu?",
      "service_menu_status_message_title": "{status} denne servicemenu?",
      "service_menu_status_message": "Du're Om til {status} servicemenu",
      "no_service_menus_in_location_title": "Opret din tilpassede servicemenu",
      "add_new_service_menu": "Tilføj ny servicemenu",
      "no_service_menus_in_location": "Start Via Oprettet en ny servicemenu og tilføj Gruppe dertil",
      "no_service_menu_found": "Der blev ikke fundet nogen servicemenu",
      "no_service_menu_found_desc": "Din Søge matchede ikke nogen servicemenuer.",
      "apply": "Anvend",
      "troubleshoot_calendar": "Fejlfind kalender",
      "round_robin_booking": "Automatisk tildeling af aftaler",
      "round_robin_description": "Fordeler Aftale blandt Gruppe Medlemmer in en roterende Sortere.",
      "round_robin_example": "F.eks.: Salg-opkald, Onboarding sessioner.",
      "unassigned_booking": "Begivenhed",
      "unassigned_description": "Til Planlæg fysisk tilfælde uden Vært Relation.",
      "unassigned_example": "F.eks.: Konferencer, Offentlige seminarer, udstillinger.",
      "class_booking": "Klasse",
      "class_booking_description": "Et Vært mødes med flere Medlemmer.",
      "class_booking_example": "F.eks.: Webinarer, Gruppe Kurser, online .",
      "collective_booking": "KOLLEKTIV Booking",
      "collective_booking_description": "Flere værter mødes med en medlem.",
      "collective_booking_example": "F.eks.: Panelinterviews, udvalgsanmeldelser.",
      "service_booking": "Booking af service",
      "service_booking_description": "Problemfri Planlæg til servicebaserede virksomheder.",
      "service_booking_example": "F.eks.: Spa Aftale, reparation Serviceydelser, konsultationer.",
      "personal_booking": "Personlig booking",
      "personal_booking_description": "Planlæg en-til-en-møder med en bestemt Gruppe Medlemmer.",
      "personal_booking_example": "F.eks.: Bygherremøder, Private konsultationer.",
      "personal": "Personligt",
      "explore_more_types": "Udforsk flere Kategorier",
      "no_calendars_added": "Ingen kalendere endnu – Samling en op!",
      "no_calendars_added_description": "Opret din første kalender for at starte Planlæg ubesværet.",
      "no_groups_added": "Ingen gruppe endnu – Begynd at organisere dig!",
      "no_calendars_yet": "Ingen kalendere endnu",
      "no_groups_yet": "Ingen gruppe endnu",
      "no_calendars_access": "Der er ikke blevet oprettet nogen kalendere endnu. Når en kalender er Oprettet, vises den hende. Du har ikke Få adgang til at opret en kalender — kontakt din Admin Hvis nødvendig.",
      "no_groups_access": "Ingen Gruppe har været Konfigurer endnu. Når en Gruppe er Oprettet, vises den hende. Du har ikke Få adgang til at Opret a Gruppe—kontakt din Admin Hvis nødvendig.",
      "no_groups_added_description": "Brug Gruppe til at se dine kalendere strukturerede. Tilføj kalendere til en gruppe og Slet en Individuel Gruppe Link til planlægning for Enkel-booking.",
      "group_success_message": "Gruppe er oprettet. Du can nu Inkludere kalendere til denne gruppe.",
      "choose_calendars": "Vælg kalendere",
      "do_it_later": "Jeg gør det senere",
      "add_calendars_to_group": "Tilføj kalendere til Gruppe",
      "select_calendars_to_add": "Vælg hver de kalendere, du vil inkludere i gruppen {name}",
      "add_calendars": "Tilføj kalender(er)",
      "continue": "Fortsætte",
      "conflicting_calendars": "Modstridende kalendere",
      "conflicting_calendars_description": "Efterfølgende kalendere er allerede en del af Andet Gruppe. Vil du flyve dem til din nye gruppe <b>{name}</b>?",
      "group_associated_with": "Aktuel Gruppe",
      "move_calendar_consent": "Jeg Aktivere Flytte disse kalendere til ny Gruppe.",
      "calendars_moved_successfully": "hver Valgt-kalendere er blevet flyttet til {name}.",
      "new_group": "ny Gruppe",
      "back": "Tilbage",
      "share_otl": "Slet din Tilgældighed hver Dato med et unikt Link , der Udløber Efter en booking, hvilket sikrer administratoren Få adgang til.",
      "copied_to_clipboard": "Kopieret til udklipsholder",
      "generate_link": "Generere ny Link",
      "generate_link_error": "Kunne ikke generere engangslink. Prøv igen.",
      "share_schedule_link": " Link til planlægning bestemmes Via Slug. Ændre the Slug, og Link til planlægningen tilpasser sig automatisk modifikationen.",
      "share_permanent_link": "Ideelt til Tragter, Website Omdirigeringer, Eller Annoncer. Det permanente Link forbliver konstant, upåvirket Via Slug Dynamisk.",
      "copy": "Kopiér",
      "share_embed_code": "Placering denne kode in din HTML , hvor du ønsker, at din {embedType} Widget skal vises.",
      "scheduling_link": "Link til planlægning",
      "permanent_link": "Permanent Link",
      "one_time_link": "Link",
      "embed_code": "Indlejringskode",
      "loading": "Indlæser...",
      "share_group": "Dele Gruppe",
      "edit_group": "Rediger Gruppe",
      "more_options": "Flere Valgmuligheder",
      "share_calendar": "Dele kalender",
      "edit_calendar": "Rediger kalender",
      "troubleshoot_calendar_link": "Fejlfind kalender",
      "calendar_config_success": "Du har konfigureret din personlige/Gruppe-kalender",
      "close": " Luk",
      "added_calendars": "Tilføjet kalender(er)",
      "select_calendars": "Vælge kalender(er)",
      "settings_confirmation": "Til Fortsæt, bekræft disse Dynamisk.",
      "consent_checkbox_title": "Jeg forstår og accepterer disse Dynamisk",
      "confirm": "Bekræft",
      "create_group_access_disabled": "Du har ikke Godkendelse til Opret a Gruppe. Kontakt din Admin for at få adgang til.",
      "create_calendar_access_disabled": "Du har ikke Godkendelse at Opret en kalender. Kontakt din Admin for at få adgang til.",
      "preview_booking_widget": "Booking-widget af Forhåndsvisning",
      "share_service_menu": "Dele Del service",
      "back_message": "Tilbage til Liste kalendere",
      "service_calendars": "Servicekalendere",
      "owned_by": "Ejet Via",
      "owned_by_anyone": "Enhver",
      "owned_by_me": "Mig",
      "all_groups": "hver Gruppe",
      "all_calendars": "hver Kalendere",
      "not_grouped": "Ikke grupperet",
      "delete_group_desc": "Er du sikker på, at du vil slette denne gruppe? Dette vil også slette hver kalenderens medlemmer med denne gruppe.",
      "calendar_listing_title": "Kalenderfortegnelse",
      "calendar_group_name": "Navn på kalender/ Gruppe",
      "success": "Gennemført",
      "my_calendar": "min-kalender"
    },
    "preferences": {
      "preferences": "Indstillinger",
      "my_preferences": "Min Præference",
      "account_preferences": "Kontopræferencer",
      "user_preferences": "Bruger Indstillinger",
      "set_preferences": "Samling af dine Indstillinger til din Konto.",
      "scheduling_options": "Planlæg Valgmuligheder",
      "meeting_location": "Konferencer Placering",
      "zoom": "Zoom",
      "save_preferences": "Arkiv Indstillinger",
      "in_app_preferences": "I app Indstillinger",
      "set_start_day": "Samling Indstillinger Synes godt om start Dag til appen",
      "view_options": "Valgmuligheder for Vis",
      "services": "Serviceydelser",
      "feature_toggle_aria": "Aktivér funktion",
      "week_starts_on": "Ugen starter på",
      "sunday": "Søndag",
      "widget_preferences": "Indstillinger for Widget",
      "set_widget_language": "Samling Indstillinger Synes godt om Sprog for Widget",
      "language_and_region": "Sprog og Stat",
      "language": "Sprog",
      "english": "Engelsk",
      "time_format": "Tidsformat",
      "time_format_value": "PM",
      "monday": "Mandag",
      "custom_meeting_location": "Tilpasset Konferencer Placering",
      "view_appointments_in_1": "Vis aftaler i",
      "timezone_uses_details_1": "Vi vil bruge denne tidszone til at vise aftaletider i hele appen og i dine aftalerelaterede e-mails – kun for dig. Den påvirker ikke din tilgængelighed, eller hvordan andre booker hos dig.",
      "business_timezones_1": "Virksomhedens tidszone",
      "business_timezones_tooltip_1": "Besked: Ved at vælge denne mulighed sikrer du, at din Præference stemmer overens med den valgte Virksomhedstidszone. Hvis virksomhedens tidszone ændres, vil din visningstidszone automatisk blive justeret for at matche.",
      "recommended_timezones": "Anbefalede tidszoner",
      "all_timezones": "Alle tidszoner"
    },
    "availability": {
      "availability": "Tilgængelighed",
      "my_availability": "Min Tilgængelighed",
      "my_availability_and_booking_rules": "Tilgængelighed og bookingregler",
      "my_availability_and_booking_rules_description": "Konfigurer din tilgængelighed, og angiv hvordan og hvornår denne kalender accepterer bookinger – herunder mødeintervaller, grænser og andre planlægningspræferencer.",
      "account_availability": "Konto Tilgældighed",
      "timezone": "Tidszone",
      "working_hours": "Arbejdstimer",
      "set_recurring_hours": "Samling af din Tilbagevendende arbejdstid for Konferencer",
      "select_one": "Vælg en",
      "sunday": "Søndag",
      "monday": "Mandag",
      "tuesday": "Tirsdag",
      "wednesday": "Onsdag",
      "thursday": "Torsdag",
      "friday": "Fredag",
      "saturday": "Lørdag",
      "widget_preferences": "Indstillinger for Widget",
      "set_widget_language": "Samling Indstillinger Synes godt om Sprog for Widget",
      "language_and_region": "Sprog og Stat",
      "language": "Sprog",
      "english": "Engelsk",
      "copy_to_all": "Kopiér to hver",
      "save_availability": "Arkiv Tilgældighed",
      "add_time": "Tilføj Dato",
      "to": "Til",
      "select_time": "Vælg Dato",
      "add_user": "Tilføj Bruger",
      "accessRestricted": {
        "header": "Få adgang til Privat",
        "message": "Du er ikke en del af denne konto. For at få adgang til, skal du inkludere dig selv til denne Konto Via Agentur Indstillinger > Gruppe > Rediger Gruppe Medlemmer, og tildel kontoen under 'Roler & Tilladelser'",
        "contact_admin": "Denne side er kun offentlig for administratorer. Kontakt din Admin for at få hjælp.",
        "button_text": "Gå til Agentur Indstillinger"
      },
      "schedule": {
        "edit_schedule": "Rediger skema",
        "schedule_name": "Skemanavn",
        "schedule_name_required": "Skemanavn er påkrævet",
        "timezone": "Tidszone",
        "timezone_placeholder": "Vælg en",
        "start_time": "Starttid",
        "end_time": "Sluttid",
        "add_availability_hour": "Tilføj tilgængelige timer",
        "remove_availability_hour": "Fjern tilgængelige timer",
        "unavailable": "Ikke tilgængelig",
        "schedule_created": "Skemaet er blevet oprettet",
        "schedule_updated": "Skemaet er blevet opdateret",
        "calendars_selected": "{count} kalender",
        "calendars_selected_multiple": "{count} kalendere",
        "select_users_placeholder": "Søg efter brugere",
        "edit_default_schedule": "Rediger dette skema",
        "customize_event_type_schedule": "Tilpas skema kun for denne kalender",
        "multi_user_description": "<b>{count} brugere</b> er blevet valgt. Opdater deres tilgængelighed for <b>{calendar}</b>",
        "selected_calendar": "valgt kalender",
        "edit_schedule_alert": "Opdateringer foretaget her vil blive anvendt på",
        "schedule": "Planlæg",
        "no_availability": "Ingen tilgængelighed",
        "date_specific_hours_show_more": "flere",
        "date_specific_hours_show_less": "færre",
        "date_specific_hours_recurring_meetings_enabled": "Datospecifikke timer kan ikke tilføjes, fordi dette skema er knyttet til en kalender med aktiverede tilbagevendende møder. Deaktiver de tilbagevendende møder for at fortsætte.",
        "recurring_incompatible_with_date_hours": "Tilbagevendende møder kan ikke aktiveres, fordi brugerens skema har datospecifikke timer, hvilket er inkompatibelt.",
        "incompatible_schedule_with_recurring": "{user} skema indeholder dato-specifikke timer, som er uforenelige med tilbagevendende møder.",
        "incompatible_schedule_with_recurring_calendar": "Skemaet indeholder dato-specifikke timer, hvilket er uforeneligt med tilbagevendende møder.",
        "recurring_meetings_enabled_multi_user": "Tilbagevendende møder kræver kun ét tildelt gruppemedlem, og deres skema må ikke inkludere datospecifikke timer.",
        "weekdays": "Hverdage, {timeRange}",
        "weekdays_hours_vary": "Hverdage, timer varierer",
        "weekend": "Weekend, {timeRange}",
        "weekend_hours_vary": "Weekend, timer varierer",
        "days_hours_vary": "{days}, timer varierer",
        "date_specific_hours_tab_name": "Datospecifikke timer",
        "date_specific_hours": "{count} datospecifikke timer",
        "date_specific_hours_1": "1 datospecifik time",
        "weekly_hours": "Ugentlige arbejdstimer",
        "custom_schedule": "Tilpasset skema",
        "select_schedule": "Vælg en skema",
        "no_schedules_found": "Ingen skemaer fundet",
        "untitled": "Uden titel",
        "error_updating_schedules": "Fejl under opdatering af tidsplaner",
        "daily": "Daglig",
        "weekly": "Ugentlig",
        "monthly": "Månedligt",
        "custom": "Tilpasset",
        "this_is_required": "Dette er påkrævet",
        "search": "Søg",
        "edit_hours": "Rediger åbningstider",
        "schedule_name_duplicate": "Der findes allerede et skema med dette navn",
        "delete_schedule_title": "Vil du slette skemaet \"{scheduleName}\"?",
        "delete_schedule_description": "Denne handling kan ikke fortrydes. Er du sikker på, at du vil fortsætte?",
        "delete_schedule_negative_text": "Annuller",
        "delete_schedule_positive_text": "Ja, slet",
        "active_on": "Aktiveret for",
        "weekly_working_hours": "Ugentlige arbejdstimer",
        "weekly_working_hours_subtext": "Vælg de dage og tidspunkter, du arbejder på",
        "copy_availability_hour": "Kopiér tilgængelige timer",
        "mins": "Minutter",
        "hours": "Timer"
      }
    },
    "connections": {
      "connections": "Forbindelser",
      "connect": "tilslut",
      "conferencing": "Konferencer",
      "my_connections": "Mine forbindelser",
      "account_connections": "Konto",
      "connection_preferences": "Indstillinger for forbindelse",
      "manage_calendars_conferencing_channels": "Administrer kalendere og Konferencer",
      "main_integration_calendar": "PRIMÆR Integration",
      "event_integration_calendar": "tilfælde Oprettet Til en System , som du er en del af, vil også være Oprettet Til denne integrerede kalender",
      "2way_sync": "2-vejs synkronisering: Opret System tilfælde fra tilfælde booket til den PRIMÆR integrerede kalender",
      "calendars": "Kalendere",
      "google": "Google",
      "outlook": "Outlook",
      "check_for_conflicts": "Flueben til konflikter",
      "choose_accounts_to_connect": "Vælg, hvilken Konto Du ønsker at oprette forbindelse",
      "payments": "Betalinger",
      "stripe": "Stripe",
      "ads": "Annoncer",
      "local_service_ads": "Lokal service Annoncer",
      "fire_workflow": "Brand Arbejdsgang Udløsere for tilfælde booket Via 2-vejs Synkronisering",
      "connect_google_outlook": "Tilslut din Google/Outlook/iCloud -konto for at kunne vælge PRIMÆR-kalender.",
      "execute_automation": "Udfør automatisering",
      "save": "Arkiv",
      "lsa": "Lokal service Annoncer",
      "no_write_access": "Du skriv ikke Få adgang til til denne kalender",
      "connection_remove_confirmation": "Du're Om to Uddrage denne Integration",
      "active": "Dynamisk",
      "icloud": {
        "title": "Integration af iCloud",
        "description": "To-faktorgodkendelse og en app-specifik password er påkrævet for at tilslutte din Konto.",
        "email": "iCloud -e-mailadresse",
        "password": "iCloud-adgangskode",
        "connect": "Tilslut",
        "cancel": "Annuller"
      }
    }
  },
  "appointment_modal": {
    "select_a_contact": "Vælge en Kontakte",
    "start_time": "Startdato",
    "unassigned": "Ikke tildelt",
    "end_time": "Slutning Dato",
    "search_by_name_email_phone_or_company": "Søge Via navn, e-mail, Telefon Eller Virksomhed",
    "add_new": "Tilføj ny",
    "pick_from_available_contacts": "Eller Vælge Fra ledige Venner",
    "book_appointment": "Book en Aftale",
    "add_blocked_off_time": "Tilføj blokeret deaktiveret Dato",
    "recommended_timezones": "Anbefalet tidszoner",
    "all_timezones": "hver tidszoner",
    "calendar": "Kalender",
    "repeat": "Gentagelse",
    "date_and_time": "Dato og Dato",
    "close": "Luk",
    "team_member": "Gruppe Medlemmer",
    "recurring_booking": "Tilbagevendende booking",
    "one_slot_booking": "Booking af et tidsrum",
    "event_type": "Begivenhedstype",
    "occurrences_booked": "tilfælde vil blive booket",
    "repeats": "Gentagelse",
    "booking_details": "Oplysninger",
    "showing_slots_in_this_timezone": "Viser-pladser in denne tidszone:",
    "update_contact_tz": "Opdater også Kontakte tidszone til",
    "date": "Dato",
    "slot": "tidsrum",
    "calendar_default": "Standard",
    "custom": "Tilpasset",
    "meeting_notes": "(f.eks.) Konferencer-noter til vores kommende Aftale",
    "out_of_office": "(eg) Fra kontor for Uge!",
    "standard": "Standard",
    "appointment_title": "Aftale Titel",
    "event_title": "Begivenhed Titel",
    "appt_with_bob": "(f.eks.) Aftale med Bob",
    "vacation": "(f.eks.) Ferie",
    "show_notes": "Vise noter",
    "hide_notes": "Skjule noter",
    "additional_preferences": "Yderligere Indstillinger",
    "meeting_location": "Konferencer Placering",
    "appointment_status": "Status for Aftale",
    "appt_description": "Beskrivelse af Aftale",
    "recurring_details": "Tilbagevendende Oplysninger",
    "event_description": "Beskrivelse af Begivenhed",
    "in_contact_timezone": "in Kontaktes tidszone",
    "vacation_message": "Skal du til ferie? Tager du noget Dato-deaktiveret? Bloker deaktiveret Dato Til din kalender for at forhindre Kunder Fra booking Aftale Aktuel Aftale vil stadig være til din kalender).",
    "contact": "Kontakte",
    "delete": "Slet",
    "cancel": "Annuller",
    "back": "Tilbage",
    "pick_available_contacts": "Eller Vælge Fra ledige Venner",
    "no_contacts_found": "Ingen Venner fundet",
    "found": "fundet",
    "select_one": "Vælge En",
    "tz_tooltip": "Dette er kun vigtigt Hvis Du're Via Brugerdefinerede værdier; såsom Aftale Aftale Aftale osv. in din Udgående Kommunikation med dine Kunder Eller Kunder. Og det, den simpelthen gør, er at konvertere de førnævnte Oplysninger til deres lokale Dato.",
    "meeting_location_tooltip": "Konferencer Placering vil være Samling som konfigureret in kalenderen.",
    "appt_meeting_location_tooltip": "Brugeren kan Samling den Konferencer-placering, der er specifik for Aftale.",
    "gmeet_tooltip": "Sørg for, at det respektive Gruppe Medlemmer har en Google Kalender Samling som deres PRIMÆR-kalender",
    "zoom_tooltip": "Sørg for, at den respektive Gruppe Medlemmer har Zoom integreret",
    "enter_meeting_location": "Indtast Konferencer Placering",
    "save_appointment": "Arkiv Aftale",
    "save_event": "Arkiv Begivenhed",
    "search_contacts": "Søge Via navn, e-mail, Telefon Eller Virksomhed",
    "recurring_slots": "{recurringSlotsLength}/{count}",
    "custom_timezone": "Tilpasset tidszone",
    "system_timezone": "System tidszone",
    "contact_timezone": "Kontakte tidszone",
    "account_timezone": "Konto tidszone",
    "an_error_occurred": "Der opstod en fejl"
  },
  "popup": {
    "calendar": "Kalender",
    "appointment_owner": "Ejer af Aftale",
    "source": "Kilde",
    "booked_by": "Booket Via",
    "view_activity_log": "Vis Aktivitetslog",
    "status": "Status",
    "cancel_appointment": "Annuller Aftale",
    "cancel_all": "Annuller hver",
    "google_event": "Google Begivenhed",
    "outlook_event": "Outlook Begivenhed",
    "blocked_slot": "Spærret tidsrum",
    "appointment": "Aftale",
    "confirmed": "Bekræftet",
    "unconfirmed": "Ubekræftet",
    "cancelled": "Aflyst",
    "showed": "Fremmødte",
    "no_show": "Udeblevet",
    "invalid": "Ugyldig",
    "more": "Mere",
    "less": "Mindre",
    "edit": "Rediger",
    "reschedule_all": "Ændre hver",
    "guests": "Gæst(er)",
    "guest_count": "Gæst(s) Optælling"
  },
  "create_calendar": {
    "calendar_name": "Kalenderens navn",
    "calendar_logo": "Logo",
    "select_team_member": "Vælge Gruppe Medlemmer",
    "select_single_team_member": "Vælg gruppemedlem",
    "eg_outbound_reach": "(f.eks.) Udgående rækkevidde",
    "description": "Beskrivelse",
    "amount": "Beløb",
    "description_placeholder": "Skriv Beskrivelse",
    "meeting_duration": "Konferencer Varighed",
    "meeting_location": "Mødested",
    "seats_per_class": "Pladser pr. Klasse",
    "group": "Gruppe",
    "custom_url": "Tilpasset URL",
    "meeting_invite_title": "Konferencer invitationstitel",
    "event_color": "Farve på Begivenhed",
    "availability_type": "Tilgældighed Skrive",
    "new_calendar": "ny Kalender",
    "add_description": "Tilføj beskrivelse",
    "remove_description": "Uddrage Beskrivelse",
    "booking_availability": "Bookingtilgængelighed",
    "slug_tooltip": "Tilpas booking-widget URL",
    "meeting_location_tooltip": "Konferencer Links er Fremmødte in Calendar tilfælde som 'Konferencer Placering' og Aktivere Du to Inkludere ting Synes godt om zoom links til Begivenhed.",
    "advanced_settings": "Avancerede Indstillinger",
    "show_more_schedule": "Vis flere",
    "show_more_helper_text": "For yderligere at tilpasse dine åbningstider skal du gå til de avancerede indstillinger",
    "reschedule_preference": "Ændre Præference",
    "reschedule_preference_subtext": "Hvis en {contactLabel} ændrer en aftale:",
    "reassign_through_round_robin": "Reassign Via Automatisk tildeling af aftaler",
    "keep_same_assinged_user": "Se den samme Aftale Ejer",
    "new_appointment_preference": "Præference for ny Aftale",
    "new_appointment_preference_text": "Book altid med {contactLabel}s tildelte bruger",
    "new_appointment_preference_subtext": "Book nye aftaler med {contactLabel}s tildelte bruger i stedet for at bruge automatisk tildeling af aftaler.",
    "cancel": "Annuller",
    "confirm": "Bekræft",
    "service_calendar_name": "Navn på service",
    "service_logo": "Logo",
    "service_select_team_member": "Vælge personalemedlem",
    "service_duration": "Service Varighed",
    "appointment_invite_title": "Titel på Aftale",
    "payment_placeholder": "Indtast en beskrivelse, der vil blive vist til brugeren, der informerer vedkommende om betalingen",
    "deposit_amount": "Indbetalingsbeløb",
    "collect_deposit_amount": "Acceptér ufuldstændig betaling",
    "percentage": "Procentdel",
    "total_amount": "Beløb i Sum",
    "enter_meeting_location": "Indtast mødested",
    "accept_payments": "Acceptér betalinger",
    "aria": {
      "should_accept_payment": "Skal acceptere betaling"
    },
    "calendar_name_tooltip": "Kalendernavnet, der skal vises indtil Booking-widgetten",
    "booking_availability_tooltip": "Indsamling af dage og tidspunkt, hvor bookinger kan foretages. Disse er din Standard Ugentlig Virksomhed tid Fremmøde til Bruger Når selecting en Tidsramme",
    "select_team_member_tooltip": "Vælg den eller de Gruppemedlemmer, der vil tage denne konference",
    "seats_per_class_tooltip": "Samling af Maks. nummer af Medlemmer tilladt at Book denne Klasse. Når hver Pladser er fyldt, vil Tidsrammen ikke længere være tilgængelig for booking",
    "meeting_color": "Konferencer Farve",
    "meeting_duration_tooltip": "Dette Fast the Længde af din Konferencer, bestemmende, hvor længe den vil sidste"
  },
  "calendar_advanced": {
    "general": {
      "quick_tip": "Hurtigt tip",
      "timezone_change_tip": "Datozoner kan være dynamiske til enhver tid under Dato Zone Indstillinger",
      "save": "Arkiv",
      "close": "Luk",
      "meeting_details": "Konferencer Oplysninger",
      "availability": "Tilgængelighed",
      "forms_and_payment": "Formularer og betaling",
      "notifications_and_additional_options": "Påmindelse & Yderligere valgmuligheder",
      "connections": "Forbindelser",
      "customizations": "Tilpasninger",
      "create": "Opret",
      "edit": "Rediger",
      "equipments": "Rum og Udstyr",
      "service_details": "Oplysninger om service",
      "saving_changes": "Kun et minut — Gemme den seneste Dynamisk ...",
      "calendar_id": "Kalender-id",
      "saveCalendarSuccess": "Kalenderen er gemt"
    },
    "meeting_details": {
      "meeting_location": "Konferencer Placering",
      "enter_meeting_location": "Indtast Konferencer Placering",
      "click_to_upload": "klik for at Upload",
      "square": "Firkant",
      "circle": "Cirkel",
      "remove_logo": "Uddrage Logo",
      "meeting_invite_title_tooltip": "Dette er titlen på kalenderen Konferencer, der Fremmødte in din Aftaler Listevisning, Kalender Vis og Tredjepartskalendere",
      "event_color_tooltip": "Vælg en Farve til denne booking Givet. Farverne synkroniseres med tilfælde in Google Kalender.",
      "enter_a_name": "Indtast et navn",
      "enter_an_event_title": "Indtast en Begivenhed titel",
      "high_priority": "Høj Prioritet",
      "medium_priority": "Medium Prioritet",
      "low_priority": "Lav Prioritet",
      "priority": "Prioritet",
      "custom": "Tilpasset",
      "zoom_not_added": "The Bruger har ikke tilsluttet deres Zoom konto endnu",
      "opt_avail": "Optimer til Tilgænglighed",
      "opt_equal": "Optimer for ligeså mange muligheder",
      "team_members": "Vælge Gruppe Medlemmer",
      "team_members_location": "Vælge Gruppe Medlemmer & Tildel Konferencer Placering",
      "team_member": "Vælge Gruppe Medlemmer",
      "team_member_location": "Vælge Gruppe Medlemmer & Tildel Konferencer Placering",
      "meeting_location_required": "Konferencer Placering er påkrævet",
      "meeting_details": "Konferencer Oplysninger",
      "meeting_details_description": "Det er de Oplysninger, der vil være Fremmødte in kalenderen Liste Side.",
      "or_drag_and_drop": "Eller Træk og slip",
      "service_details": "Oplysninger om service",
      "team_member_disabled_recurring_tooltip": "Tilbagevendende møder Aktivere kun én Gruppe Medlemmer. For at inkludere flere Gruppe Medlemmer, bedes du Deaktivere Tilbagevendende møder.",
      "team_member_disabled_class_booking_tooltip": "Der kan kun føjes én Gruppe Medlemmer til en Klasse Bookingkalender",
      "advanced_settings": "Avancerede Indstillinger",
      "enable_contact_assigned_to_setting": "For at aktivere denne Indstilling skal Formularen være først in Widget -sorteringen. Ændre the Widget Sortere fra fanen Formularer og betaling.",
      "reschedule_preference_setting_tooltip": "Vælg hvem aftalen skal tildeles, når en {contactLabel} flytter fra booking-widgetten.",
      "appointment_preference_tooltip": "Vælg, om nye aftaler altid skal bookes med den bruger, der er tildelt {contactLabel}. Hvis en {contactLabel} har en tildelt Bruger, vil denne Bruger have Præference; ellers vil det være en Automatisk tildeling af aftaler. Tip: Deaktiver \"Tillad personalevalg\" for at forhindre bookere i at ændre medarbejderen i booking-widgetten.",
      "add_location": "Tilføj Placering",
      "multiple_locations_neo": "Flere Konferencer-adresser understøttes kun Via Neo Widget.",
      "make_owner": "Opret Ejer",
      "only_one_team_member": "Kun ét Gruppe-medlem er tilladt, når der er tilføjet flere adresser.",
      "ask_the_booker_error_message": "Spørg Booker Placeringen findes allerede",
      "enter_location": "Værdi Placering",
      "enter_display_label": "Indtast Visning",
      "add_display_label": "Tilføj Visning",
      "multiple_location_support_message": "Flere Konferencer-adresser understøttes kun Via Neo Widget.",
      "only_one_team_member_personal_calendar": "Kun én Gruppe Medlemmer er tilladt til personlig booking ",
      "ms_teams_not_added": "Brugeren har ikke tilsluttet deres Microsoft Gruppe Konto endnu",
      "enable_new_appt_preference": "Aktivere ny Aftale Præference",
      "enable_new_appt_preference_desc": "Når du aktiverer &quot;<b>Book altid med {contactLabel}s tildelte Bruger</b>&quot;, vil <b>formularen</b> automatisk blive indstillet som det første trin i widgetrækkefølgen.",
      "location_exists_toast": "Konferencer Placering allerede tilføjet",
      "not_supported_with_multiple_team_members": "Understøttet ikke af Multiple Gruppe Medlemmer",
      "not_supported_personal_calendar": "Understøttet ikke in personlig kalender",
      "not_supported_class_booking": "Understøttet ikke in Klasse Bookingkalender",
      "not_supported_collective_booking": "Understøttet ikke in KOLLEKTIV-kalenderen",
      "not_supported_service_booking": "Understøttet ikke in Bookingkalender",
      "not_supported_round_robin": "Ikke understøttet in Automatisk tildeling af aftaler kalender",
      "not_supported_event": "Understøttet ikke in Begivenhed-kalenderen",
      "calendar_logo_tooltip": "Vælg et Logo , der skal være Fremmøde til Booking-widgeten",
      "calendar_name_tooltip": "Kalendernavnet, der skal vises indtil Booking-widgetten",
      "description_tooltip": "Beskriv, hvad kalenderen er Om, der skal vises til Booking-widgeten",
      "group_tooltip": "Du kan tildele denne kalender til en Hvis Oprettet. Bruger Få adgang til Gruppe Link kan gennemse og Book hver kalendere in den gruppe",
      "custom_url_tooltip": "Tilpas booking-widget URL",
      "meeting_color_tooltip": "Vælg en Farve til denne booking Givet. Farver får Synkronisering til Begivenheder in Google Kalender",
      "add_display_label_tooltip": "For at maskere placeringen, hvis der er flere placeringsvalgmuligheder tilgængelige",
      "meeting_location_tooltip": "Vælg, hvordan Eller, hvor udbyderen vil tage Placering",
      "team_members_location_tooltip": "Vælg den Gruppe Medlemmer, der vil tage denne konferencer",
      "meeting_distribution": "Konferencer Levering",
      "meeting_distribution_tooltip": "Vælg, hvordan aftalere er fordelt på tværs af dine Valgt Gruppe Medlemmer — baseret Til Tilgængelighed Eller lig Levering",
      "opt_avail_tooltip": "Tildel møder til Gruppe Medlemmer, der er tilgængelig på Valgt Dato, uanset tidligere bookinger. Maksimerer Åbne tidsrum udnyttelse og booking Gennemført Frekvens",
      "opt_equal_tooltip": "Udgive møder Lige blandt hver Gruppe Medlemmer Via tracking tidligere bookinger. Prioriterer retfærdighed frem for Tilgægelselighed",
      "priority_tooltip": "Samling af Præference Flad til tildeling af møder, når flere Gruppe Medlemmer er tilgængelige. Højere prioritet Medlemmer vil blive betragtet som den første ved bookinger, Følge Via Medium og lav prioritet Medlemmer",
      "contact_routing_preference": "Præference for Kontakte Routing",
      "contact_routing_preference_tooltip": "Definer, hvordan nye og tilbagevendende {contactsLabel} tildeles gruppemedlemmer – enten via automatisk tildeling af aftaler eller deres oprindelige ejer",
      "team_members_location_owner_tooltip": "Den PRIMÆR Bruger, der ejer Konferenceren og giver den endelige Konferencer Placering",
      "owner": "Ejer",
      "upload_from_system": "Upload fra system",
      "choose_from_media_storage": "Vælg fra mediedrev",
      "only_one_team_member_allowed": "Kun ét teammedlem er tilladt.",
      "at_least_two_team_members_required": "Mindst 2 teammedlemmer er påkrævet",
      "at_least_one_team_member_required": "Mindst ét teammedlem er påkrævet"
    },
    "availability": {
      "my_availability": "Min Tilgænglighed",
      "set_availability": "Samling af din Tilgældighed til kalenderen hende.",
      "standard": "Standard",
      "custom": "Tilpasset",
      "to": "Til",
      "copy_to_all": "Kopiér to hver",
      "add_time": "Tilføj Dato",
      "recurring_meeting": "Tilbagevendende Konferencer",
      "recurring_info": "Kun én Bruger pr. kalender for Tilbagevendende booking",
      "repeat": "Gentagelse",
      "times_to_repeat": "gange til Gentagelse",
      "slots_unavailable": "Hvis tidsrum ikke er tilgængelige?",
      "overlap_status": "Aftale Status for overlappende tidsrum ",
      "meeting_interval": "Mødeinterval",
      "meeting_duration": "Konferencer Varighed",
      "minimum_scheduling": "Min.. Planlæg MEDDELELSE",
      "date_range": "Dato Omfang",
      "maximum_bookings_per_day": "Maks. bookinger pr. Dag",
      "maximum_bookings_per_slot": "Maks. bookinger pr. . tidsrum",
      "maximum_bookings_per_slot_per_user": "Maks. bookinger pr. tidsrum (pr. Bruger)",
      "seats_per_class": "Pladser pr. Klasse",
      "pre_buffer_time": "Før BUFFER Dato",
      "post_buffer_time": "Slet BUFFER Dato",
      "pre_buffer_tooltip": "Pre-buffer er ekstra Dato, der kan tilføjes før en Aftale, Aktivere for ekstra Dato for at få Parat",
      "post_buffer_tooltip": "Post-Buffer er ekstra Dato, der kan tilføjes Efter an Aftale, Aktivere for ekstra Dato at pakke op",
      "buffer_time": "BUFFER Dato",
      "daily": "Daglig",
      "weekly": "Ugentlig",
      "monthly": "Månedlig",
      "skip_booking": "Spring over booking af ikke-tilgængelige tidsrum",
      "continue_booking": "Fortsætte med at booke",
      "book_next_available": "Book Næste tilgængelige tidsrum",
      "confirmed": "Bekræftet",
      "unconfirmed": "Ubekræftet",
      "enter_valid_hours": "Indtast en gyldig Åbne-tid",
      "enter_valid_avail": "Indtast en gyldig Tilpasset tilgældighed",
      "availability_type_tooltip": "Vælge Standard Tilgængelighed for månedlige bookinger, der tilbydes Ugentlig. Vælge Tilpasset for bookinger kun tilgængelig til specifikke datoer.",
      "meeting_interval_tooltip": "Konferencer Sekunder afspejler beløbet af Dato de mellem bookinger, der vil være fremmødte in kalenderen. I 30 Min.. I betragtning af at skulle være tilgængelig til Øverst / Mest populære af hver gang, ville kunderne være 1 time. I 30 Min.. Hvis det skulle være tilgængeligt hver 30 minutter, ville kunden være 30 minutter.",
      "date_range_tooltip": "tilfælde kan være planlagt over de næste n dage.",
      "maximum_bookings_per_day_tooltip": "Maks. antal af møder tilladt pr. Dag Til denne kalender",
      "maximum_bookings_per_slot_tooltip": "Maks. nummer af Aftale tilladt pr. tidsrum for Brugeren (Hvis nummeret af Aftale overstiger det givne tidsrum for brugeren, Så det Eller skifter over til Næste Bruger in Automatisk tildeling af aftaler-køen Eller Vandmærke tidsrum, der er ikke tilgængeligt for Muligheden at Book).",
      "add_days": "Tilføj dage",
      "month_on_day": "Månedlig Til Dag",
      "month_on_last_day": "Månedlig Til sidste",
      "day": "Dag",
      "week": "Uge",
      "month": "Måned",
      "mins": "Minutter",
      "hours": "Timer",
      "days": "Dage",
      "weeks": "Uger",
      "months": "Måneder",
      "meeting_interval_error": "Konferencer skal være mellem 5 og 12 gange",
      "meeting_duration_error": "Konferencer Varighed skal være mellem 1 Min.. og 12 gang",
      "buffer_time_error": "BUFFER Dato skal være mindre end 12 gange",
      "appointment_interval": "Aftale Kunder",
      "appointment_duration": "Aftale Varighed",
      "maximum_appointments_per_day": "Maks. Aftale pr. Dag",
      "subTitle": "Vælg det specifikke tidspunkt for Dato to Samling",
      "heading_1": "Ugentlig Tilgængelige timer",
      "scheduling_availability_heading": "Tilgængelighed for booking",
      "tooltip_1": "Samling dit Ugentlig Tilgældighed skema. Dette er din Standard , der vil blive anvendt konsekvent på Ugentlig basis",
      "heading_2": "Hvornår er du tilgængelige?",
      "unavailable_label": "Ikke tilgængelig",
      "tooltip_2": "Ændre dit skema til specifikke datoer. Tilsidesættelse af din Månedlig Ugentlig tid Via markering af Tilgængelighed Eller ikke tilgængelighed for Valgt datoer.",
      "date_specific_level": "Tilføj Dato-specifikt tidspunkt",
      "specific_hours_button": "Datospecifikke Dato",
      "specific_hours_description": "Tilsidesæt din tilgængelighed for specifikke datoer, når dine arbejdstider afviger fra dine normale ugentlige arbejdstider.",
      "overlap_error": "Datotidsrum kan ikke OVERLAPERE",
      "apply": "Anvend",
      "copy_times_to": "Kopiér gange til",
      "no_date_specific_heading": "Ingen dataspecifik data tilføjet",
      "no_date_specific_description": "Du kan Inkludere/Uddrage specifikke Dato og Dato til din Tilgængelighed",
      "recurring_disabled_conditions_tooltip": "Tilbagevendende møder er deaktiveret. For at udløse dem skal du sikre dig, at kalenderen kun har én Gruppe Medlemmer og ikke er tilføjet et datospecifikt klokkeslæt Eller ufuldstændig betaling.",
      "date_specific_hours_disabled_conditions_tooltip": "For at inkludere et datospecifikt tidspunkt, bedes du sikre dig, at Tilbagevendende møder er deaktiveret.",
      "recurring_disable_event_calendar_conditions": "Tilbagevendende møder er deaktiveret. For at udløser dem sikre, at der ikke er tilføjet et datospecifikt tidspunkt Eller ufuldstændig betaling.",
      "service_duration": "Service Varighed",
      "service_interval": "Serviceydelser",
      "service_interval_tooltip": "Konferencer. Hurtig, hvor ofte vises bookingtidspunkter Til kalenderen. For Model, i 30 minutter, betyder 1-gangskunder, at der vises tidsrum hver gang. En 30-minutters bruger betyder, at tidsrum vises hver 30. minut.",
      "service_duration_tooltip": "Denne Fast the Længde af din Aftale, bestemmende, hvor længe den vil sidste.",
      "minimum_scheduling_tooltip": "Denne hurtige er Min.. Dato Påkrævet at Book en Aftale Via kalender- Widget. For Model, Hvis Samling til 4 gang, kan Aftale ikke bookes inden 4 gang efter deres start Dato; bookinger skal foretages mindst 4 gange in forvejen.",
      "look_busy_title": "Se travl ud",
      "look_busy_helper_text": "Skjule en Procentdel af dine tilgængelige Aftale-spillemaskiner, Til Booking-widgeten for at fremstå mere travl og in",
      "look_busy_percentage_description": "Skjule antallet af ledige tidsrum Via x%.",
      "maximum_bookings_per_slot_tooltip_personal": "Begræns, hvor mange møder, der kan planlægges til den samme Tidsramme",
      "enable_recurring_title": "Aktivere Tilbagevendende Konferencer",
      "enable_recurring_desc": "Hvis du slår Til <b>Tilbagevendende Meetings,</b> deaktiveres de Efterfølgende Indstillinger automatisk, da de ikke kan eksistere sammen:",
      "date_specific_hours": "hver <b>Datospecifikke timer</b> vil være Slettet.",
      "multiple_team_members": "<b>Flere Gruppe-medlemmer</b> vil blive Afmeldt – kun én Gruppe-medlem kan være tilbage in denne kalender.",
      "partial_payments": "<b>Ufuldstændig Betalinger</b> deaktiveres, og det fulde beløb vil blive opkrævet.",
      "select_team_member_to_keep": "Vælg en Gruppe Medlemmer at se in denne kalender:",
      "select_team_member": "Vælge Gruppe Medlemmer",
      "partial_payments_disabled": "Da Ufuldstændig Betalinger vil være deaktiveret, hvordan ville Du Synes godt om at opkræve det fulde beløb for Tilbagevendende Aftale?",
      "enable_date_specific_hours": "Aktivere Dato timer",
      "enable_date_specific_hours_desc": "Hvis du slår til <b>datospecifikke timer,</b> deaktiveres Efterfølgende Indstilling automatisk, da de ikke kan eksistere side om side:",
      "recurring_meetings_disabled": "<b>Tilbagevendende møder vil blive deaktiveret</b>. {contactsLabel} vil kun kunne booke individuelle aftaler baseret på de tilgængelige datoer, du har angivet.",
      "payment_preference": "Præference for betaling:",
      "team_members_in_this_calendar": "Gruppe Medlemmer in denne kalender",
      "other_team_members": "Andet Gruppe Medlemmer (ikke tilføjet til denne kalender)",
      "select_team_member_tooltip": "Vælg den eller de Gruppemedlemmer, der vil tage denne konference",
      "meeting_duration_tooltip": "Dette Fast the Længde af din Konferencer, bestemmende, hvor længe den vil sidste",
      "date_specific_hours_tooltip": "Ændre dit skema til specifikke datoer. Tilsidesætter din Månedlig Ugentlig tid Via markering Tilgældighed Eller utilgængelighed for Valgt datoer",
      "recurring_meeting_tooltip": "Aktive møder til Gentagelse flere gange over en Uge",
      "repeat_frequency_tooltip": "Vælge Frekvens af denne Tilbagevendende begivenhed",
      "time_to_repeat_tooltip": "Samling the Sum nummer af Gentagelse",
      "slots_unavailable_tooltip": "Vælg, hvad der skal ske, hvis et eller flere Dato-tidsrum in en Tilbagevendende booking er allerede booket",
      "skip_booking_tooltip": "Kun de ledige tidsrum vil blive booket. Eventuelle ikke tilgængelige datoer in Tilbagevendende-serien vil blive sprang over",
      "force_book": "Force- Book",
      "force_booking_tooltip": "der vil blive booket hver tidsrum, Lige Hvis Der er et Konflikt. Brug sammen med Advarsel for at undgå Dobbeltbookinger",
      "book_next_available_tooltip": "Hvis en Valgt tidsrum er ikke tilgængelig, Book det Næste tilgængelige tidsrum Til det samme Tilbagegevendende skema (f.eks. Næste Mandag hvis Ugentlig)",
      "slot_interval_tooltip": "Samling af afstanden mellem startgangene af på hinanden følgende tilgængelige tidsrum. Til Model, Hvis din Konferencer Varighed er 30 minutter og Du Samling sekunderne til 60 minutter, kan en Bruger Book AM 9:00 , Så AM, og så Til — Lige, selvom hver Konferencer kun varer 30 minutter",
      "minimum_scheduling_notice_tooltip": "Påkrævet Bruger at Book møder mindst så meget Dato in forhånd",
      "date_range_preferences_tooltip": "Samling af, hvor langt ud i fremtiden bookinger kan foretages Fra I dag's Dato",
      "maximum_bookings_per_slot_preferences_tooltip": "Begræns, hvor mange møder, der kan planlægges til den samme Tidsramme",
      "maximum_bookings_per_slot_per_user_preferences_tooltip": "Begræns, hvor mange møder, der kan planlægges til den samme Tidsramme (pr. Bruger)",
      "pre_buffer_time_tooltip": "Dato for at blokere Før hver Konferencer, Aktivere for at få ekstra Dato til at forberede",
      "post_buffer_time_tooltip": "Dato for at blokere efter hver konferencer, Aktivere for ekstra Dato til afslutning",
      "seats_per_class_tooltip": "Samling af Maks. nummer af Medlemmer tilladt at Book denne Klasse. Når hver Pladser er fyldt, vil Tidsrammen ikke længere være tilgængelig for booking",
      "maximum_bookings_per_slot_per_user_tooltip": "Begræns, hvor mange møder, der kan planlægges til den samme Tidsramme (pr. Bruger)",
      "repeat_frequency": "Gentagelse Frekvens",
      "slot_interval": "tidsrum kunder",
      "skip_booking_helper_text": "Kun de ledige tidsrum vil blive booket. Eventuelle ikke tilgængelige datoer in Tilbagevendende-serien vil blive sprang over",
      "force_book_helper_text": "der vil blive booket hver tidsrum, Lige Hvis Der er et Konflikt. Brug sammen med Advarsel for at undgå Dobbeltbookinger",
      "book_next_available_helper_text": "Hvis et Valgt tidsrum er ikke tilgængeligt, Book det Næste tilgængelige tidsrum Til det samme Tilbagegevendende skema (f.eks. Næste Mandag Hvis Ugentlig).",
      "bulk_edit": "Masserediger",
      "select_users": "Vælg brugere",
      "select_all": "Vælg alle",
      "times_to_repeat_tooltip": "Angiv det samlede antal hændelser"
    },
    "forms_payment": {
      "forms": "Formularer",
      "forms_sub": "Samling post-Planlæg Formular Indstillinger.",
      "select_form": "Vælg formular",
      "enable_same_user_assignment": "Tildel Venner til deres respektive kalender Gruppe Medlemmer hver Dato an Aftale er booket",
      "sticky_contacts": "Forududfyld Felter (Fastgjort Venner)",
      "confirmation_page": "Bekræftelsesside",
      "default": "Standard",
      "redirect_url": "Omdirigerings-URL",
      "thank_you": "Tak Du Besked",
      "enter_url": "Indtast URL",
      "amount_tab_hidden_label": "Pladsholder til fanen Beløb",
      "percentage_tab_hidden_label": "Procent fanepladsholder",
      "pixel_id": "Meta Pixel-id (Valgfri)",
      "auto_confirm": "Bekræft automatisk ny kalendermøder",
      "configure_payment": "Konfigurer betalinger Valgmuligheder",
      "accept_payments": "Acceptér betalinger",
      "test": "Test",
      "live": "Live",
      "enable_guests": "Tilføj gæster",
      "add_guest_tooltip": "Tilføj Gæst vil aktivere din Gæst for at inkludere flere deltagere til den samme Aftale",
      "add_guest_custom_form_tooltip": "Hvis du aktiverer denne mulighed, Upload en systemgenereret e-mail til gæster med et Link til Tilpasset-formularen, når deres Aftale er Bekræftet. For at forhindre Duplikere Gmail skal du sikre dig, at en separat bekræftelsesmail ikke allerede er Konfigurer for gæster. (Bekræft dette in fanen Påmindelse > Bekræftelsesnotifikation)",
      "add_guest_same_form_check": "Upload samme formular for at indsamle Oplysninger Via mail til hver gæster",
      "payment_tooltip": "Betaling vil kun komme i betragtning for PRIMÆR Gæst og ikke for gæster.",
      "default_form": "Standard (Fornavn, sidste navn, E-mail, Telefon, Noter)",
      "select_form_tooltip": "Hvis Du ville Synes godt om at indsamle flere Oplysninger end Standard , sidste navn, E-mail og Telefon Fra dem, der Book Til denne kalender, Opret et Tilpasset Formular in Sites > Formularer > Skaber Så Vælge formularen Via Rullelisten under.",
      "confirmation_page_tooltip": "Når nogen har foretaget en booking, kan du vælge at vise vedkommende en Tilpasset Besked til den samme side (Standard) eller omdirigere dem til en side efter dit valg (Omdirigering).",
      "add_guest_collect_email": "Navn og e-mail",
      "add_guest_count_only": "Kun Optælling",
      "custom_email_notification": "Upload Tilpasset Formular til gæster",
      "consent_label": "Samtykke Afkrydsningsfelt",
      "consent_input_placeholder": "Tilføj Samtykke Indhold",
      "same_user_assignment_tooltip": "For at aktivere denne Indstilling skal Formularen være først Til Widget. Ændre Widget til at Status the Formular første til at udløse denne Indstilling.",
      "consent_tooltip": "Aktivér denne indstilling for at tillade indhentning af samtykke fra {contactsLabel}, når de angiver deres telefonnummer under aftalebookingprocessen.",
      "stripe_error": "Op til to decimaler (Model: 25,99)",
      "auto_confirm_service": "Bekræft automatisk ny Aftale",
      "service_form_message": "Hvis en kontakte booker flere Serviceydelser, vil de kun se Standard in servicemenuen",
      "deposit_amount_error": "Indbetalingsbeløbet skal være mindre end Sum .",
      "deposit_percentage_error": "Indbetalings Procentdel skal være mindre end 100 %.",
      "partial_payment_tooltip": "Aktivere Ufuldstændig betalinger for at opkræve indbetalingsbeløb Fra Kunder under Aftale-bookingsprocesserne",
      "partial_payment_enable_error": "Det indtastede Sum skal være større end 0 for Aktivere ufuldstændig betalinger.",
      "payment_disable_text_integration": "Integrer en betaling Udbyder under Betalinger > Integrationer for at begynde at acceptere betalinger",
      "payment_disable_text_recurring": "Betalingsmuligheden accepterer er ikke tilgængelig for Tilbagevendende møder. Deaktiver Tilbagevendende til Aktivere betalinger.",
      "date_and_time_selector": "Dato- og datavælger",
      "form_selector": "Formular",
      "order_step": "Trin",
      "widget_order_label": "Sortere Widget",
      "widget_order_tool_tip": "Ændre 'Dato- og Datovælger' og 'Formular' sorteringen til kalender- Widget. Du skal bare Træk og genbestille pr. din Præference.",
      "widget_re_order_tooltip": "Omarrangering er kun tilgængelig med Neo Widget -stilen. Skift til Neo til Aktivere omarrangering.",
      "widget_re_order_disabled_tooltip": "For at ændre rækkefølgen af widgets skal du deaktivere 'ny aftalepræference (book altid med {contactLabel}s tildelte bruger)' fra mødeoplysninger > gruppemedlemmer > avancerede indstillinger.",
      "payment_description_error": "Maks. Tegn SLOTMAX af 1000 nået",
      "widget_multiple_location_disabled_tooltip": "Klassisk- Widget understøtter ikke flere Konferencer-adresser. Udtræk eventuel yderligere adresse for at bruge Klassisk Widget",
      "recurring_payment_label": "Tilbagevendende Aftale betaling",
      "enable_payments_for_guests": "Aktivere betalinger for gæster",
      "guest_payment_description": "Da Du've Aktiveret muligheden \"Tilføj Gæster\", kan Du også Vælge til pris pr. Gæst Når af booking.",
      "charge_per_attendee": "pris pr. Gæst",
      "charge_per_attendee_description": "Multiplicer Sum Via nummer af deltagere (inklusive gæster), når der opkræves betaling under booking.",
      "click_confirm_description": "Klik på Gem for at anvende disse ændringer.",
      "multiply_amount_guests": "Opkræve betaling for hver deltager",
      "multiply_amount_guests_description": "Når Aktiveret vil det beløb, der skal opkræves under booking blive ganget Via Sum nummer af deltagere inklusiv gæster",
      "first_appointment_only": "pris kun for den første Aftale",
      "all_appointments": "pris for hver Aftale upfront",
      "no_payment_provider_connected": "Ingen betaling Udbyder tilsluttet",
      "no_default_payment_provider": "Ingen betaling Udbyder tilsluttet",
      "provider_not_supported": "Standard Udbyder understøttes ikke",
      "manage_payment_provider": "Administrer betalingsudbydere",
      "supported_providers": "Understøttede udbydere",
      "paypal_razorpay_helper_text": "Payments will be processed through Razorpay only, as PayPal isn’t supported with custom providers",
      "rearrange_widget_order": "Ændre Widget Sortere",
      "change_form_order": "Dynamisk formularen til anden Trin in Widget Sortere vil deaktivere Efterfølgende Indstilling:",
      "change_form_order_desc": "<b>Ny præference for aftale (book altid med {contactLabel}s tildelte bruger)</b> vil blive deaktiveret. Dette betyder, at aftaler kan bookes med ethvert tilgængeligt gruppemedlem i stedet for at være begrænset til den {contactLabel}s tildelte bruger.",
      "enable_mandatory_guest": "Opret tilføjer mindst ét Gæst Påkrævet. Gæst Felter vil være forudåbnet og skal udfyldes før booking.",
      "enable_mandatory_guest_count": "Tag Påkrævet Gæst Optælling Til Booking-widget",
      "require_guest_for_booking": "Påkrævet Gæster til Booking",
      "sticky_contacts_tooltip": "Forudfyld felter for kendt {contactsLabel}.",
      "auto_confirm_tooltip": "Vandmærke ny møder som Bekræftet automatisk uden at kræve Manuel Godkendelse. Deaktiver denne Hvis du ønsker at anmeldelse og bekræfte hver booking manuelt Før det er Planlagt",
      "confirm_tooltip": "Når en person har foretaget en booking, kan du vælge at vise vedkommende en Tilpasset Besked til den samme side (Standard) eller omdirigere vedkommende til en side, efter dit valg (Omdirigerings-URL)",
      "facebook_pixel_id_tooltip": "",
      "accept_payments_tooltip": "Aktivere Samling af betaling under bookinger",
      "total_amount_tooltip": "Samling af Sum pris for udbyderen",
      "deposit_amount_tooltip": "Beløb, der skal opkræves ved booking som depositum",
      "multiply_amount_guests_all_guests": "Opkræve betaling for hver deltagere, herunder gæster",
      "multiply_amount_guests_all_guests_tooltip": "Når Aktiveret vil det beløb, der skal opkræves under booking blive ganget Via Sum nummer af deltagere inklusiv gæster",
      "payment_description": "Beskrivelse af betaling",
      "payment_description_tooltip": "Inkludere valgfrit eventuelle hjælpsomme Oplysninger Om betalingen",
      "test_mode_warning": "TestDynamisk – ingen reel Salg vil blive behandlet.",
      "pixel_id_tooltip": "Upload Booking-widget Aktivitet Synes godt om Visninger, klik og indsendelser til Meta Via dit Pixel-id",
      "forms_description": "Konfigurer filtret og Flyde af din bookingformular",
      "payment_mode": "Betalingsmetode",
      "payment_mode_tooltip": "Skift mellem Testtilstand og Live tilstand for betalinger. in Testtilstand laves ingen reel fakturering — brug den til at simulere booking- og betalingsprocesser. Skift til Live tilstand for at acceptere faktiske betalinger Fra Kunder.",
      "enable_coupon": "Aktivér kuponkoder",
      "enable_coupon_tooltip": "Aktivere Kunder at Gem Kuponkoder under reservationen. For at sikre, at de fungerer, skal du først oprette gyldige Kuponkoder under Betaling > Kuponkoder"
    },
    "notifications": {
      "notifications": "Påmindelse & Yderligere valgmuligheder",
      "notifications_sub": "Konfigurer Notifikation og yderligere Valgmuligheder",
      "edit": "Rediger",
      "created_on": "Oprettet den",
      "updated_on": "Opdateret den",
      "delivered": "Leveret",
      "not_available": "Ikke relevant",
      "select_notification_type": "Vælge Skrive af Notifikation",
      "notification_person": "Hvem skal levere denne notifikation?",
      "contact": "{contactLabel}",
      "guest": "Gæst",
      "assigned_user": "Tildelt Bruger",
      "emails": "Gmail",
      "alert_email_address": "E-mailadresse til Advarsel",
      "ack_email": "Anerkendelse E-mail",
      "send_google_invites": "Aktivere Google Kalender for at Upload invitation eller opdater Gmail til deltagere.",
      "send_google_outlook_invites": "Aktivere Google / Outlook / iCloud Kalender til at Upload invitation & Opdatere e-mails til deltagere.",
      "assign_user_to_contact": "Tildel {contactsLabel} til deres respektive kalendergruppemedlemmer hver gang en aftale bookes",
      "skip_assigning_user_to_contact": "Spring tildeling af {contactLabel} over, hvis {contactLabel} allerede har en tildelt bruger",
      "assigned_staff": "Tildelt personale",
      "additional_emails": "Yderligere Gmail",
      "assign_user_to_staff": "Tildel {contactsLabel} til deres respektive servicemedarbejdere, hver gang der bookes en aftale",
      "allow_cancellation": " Aktivere annullering af Konferencer",
      "allow_reschedule": "Aktivere Rescheduling af Konferencer",
      "allow_cancellation_tooltip": "Når Aktiveret, vil blive tilføjet et Link til de ekstra noter Afsnit og inkluderet in kalenderinvitationen. Dette Link vil Udløbet som konfigureret før Konferenceren starter Dato, hvilket forhindrer Booker Fra i at annullere Konferenceren.",
      "allow_reschedule_tooltip": " Når Aktiveret, vil et Link til omplanlægning blive tilføjet til de ekstra noter Afsnit og inkluderet in kalenderinvitationen. Dette Link vil Udløbet som konfigureret før Konferenceren starter Dato, hvilket forhindrer Booker Fra i at omplanlægge Konferenceren.",
      "cancellation_link_expiry": "Link vil Udløbet",
      "reschedule_link_expiry": "Omlægning af Link vil Udløbet",
      "before_meeting": "Før Konferenceren",
      "cancellation_and_reschedule_policy": "Politik for afbestilling og Ændre :",
      "meeting_invite_notes": "Konferencer-invitationsnoter",
      "meeting_invite_notes_tooltip": "Tilføj noter, der vises in den kalenderinvitation, der er sendt til Kunder. Disse Noter vil Synkronisering til Tredjepartskalendere in Konferencer Beskrivelse"
    },
    "connections": {
      "connections_heading": "Tredjepartskalendere Synkronisering",
      "connections_sub": "Synkronisering tilfælde med Tredjepartskalendere",
      "link_to_calendar": "Link til kalender",
      "sync_option": "Mulighed for Synkronisering",
      "execute_automation": "Udfør automatisering",
      "fire_workflow": "Udløs arbejdsgang-udløsere for begivenheder booket via to-vejs-synkronisering",
      "reserve_with_google": "Book med Google [To Be forældet]",
      "reserve_with_google_setup": "Vis Konfig Instruktioner",
      "reserve_with_google_configure": "Konfigurer",
      "change": "Skift",
      "rwg_deprecation_notice": "Google har <strong>forældet Book med Google (RwG)</strong>, kendt som <strong>Local Serviceydelser Annoncer</strong>. ny-forbindelser understøttes ikke længere. For at Fortsætte Modtaget-bookinger Via Google, bedes du bruge <strong>Google Organic Booking</strong> i stedet.",
      "rwg_category": "Kategori",
      "rwg_service_type": "Service",
      "connect_lsa": "Forbind med din lokale Serviceydelser Reklamekonto",
      "reserve_error": "nu Book med Google understøttes kun for \"Home Serviceydelser\", \"Real Estate\", \"Legal Serviceydelser\" (lokale serviceudbydere) Virksomhedsniche in USA.",
      "one_way": "En vej",
      "two_way": "To-vejs",
      "smart": "Smart",
      "confirm_remove": "Er du sikker på, at du vil Uddrage Google Kalender?",
      "read_only_access": "Du har ikke skrive Få adgang til til denne kalender. Vælg en anden kalender.",
      "reserve_with_google_desc": "Denne kalenderservice vil blive opført in Book kun med Google indtil en vellykket Integration.",
      "check_integration": "Status din Integration",
      "setup_external": "Konfig din Tredjepartskalendere",
      "reserve_price_decimal_error": "Decimal Pris understøttes ikke",
      "reserve_price_max_error": "Understøttet Pris mindre end 1000",
      "link_to_calendar_tooltip": "Vælg den kalender, som du vil synkronisere denne kalender med",
      "one_way_sync": "Envejs",
      "default_one_way": "Standardsynkronisering (envejssynkronisering)",
      "one_way_sync_desc": "Begivenheder fra den tilknyttede kalender synkroniseres som blokerede tidsrum, og der oprettes ingen kontakter for gæsterne.",
      "two_way_sync": "To-vejs-synkronisering",
      "two_way_sync_desc": "Kontakter oprettes for gæster, der forefindes i begivenheder i forbundne kalendere, og disse begivenheder omdannes til systemaftaler.",
      "smart_sync": "Smartsynkronisering",
      "smart_sync_desc": "Begivenheder fra den tilknyttede kalender synkroniseres som aftaler for eksisterende kontakter. Hvis der ikke findes nogen kontakter, synkroniseres de som blokerede tidsrum uden at oprette en ny kontakt.",
      "sync_option_tooltip": "Vælg, hvordan begivenheder fra din eksterne kalender skal synkroniseres med denne kalender. Du kan kun blokere tilgængelighed, eller også oprette/administrere {contactsLabel} og aftaler her – baseret på den synkroniseringstilstand, du vælger",
      "one_way_sync_tooltip": "Blokerer Dato-tidsrum Via import af optaget Begivenheder Fra din Tredjepartskalendere",
      "two_way_sync_tooltip": "Importerer møder og opretter {contactsLabel} aftaler i systemet. Ændringer foretaget her vil blive afspejlet i den eksterne kalender",
      "smart_sync_tooltip": "Importerer møder og opretter kun aftaler, hvis mødet blev oprettet af en kendt {contactLabel}",
      "default_sync": "Standard",
      "default_sync_desc": "Synkroniserer begivenheder fra din eksterne kalender til denne kalender",
      "advanced_sync": "Avanceret",
      "advanced_sync_desc": "Synkronisering af begivenheder fra din eksterne kalender til denne kalender og opretter kontakter og aftaler i systemet",
      "assign_contact_to": "Tildel kontakt til",
      "select_calendar": "Vælg kalender",
      "sync_preferences": "Synkroniseringsindstillinger",
      "sync_preferences_desc": "Hvordan vil du gerne synkronisere dine sammenkædede kalenderbegivenheder?",
      "recommended": "Anbefalet",
      "execute_automation_desc": "Udfør automatisering, når et møde oprettes i denne kalender",
      "save": "Gem ændringer",
      "cancel": "Annuller"
    },
    "extras": {
      "extras": "Tilpasninger",
      "extras_sub": "Samling Widget style og Andet Indstillinger.",
      "calendar_widget_style": "Stil for Widget",
      "neo": "Ny",
      "classic": "Klassisk",
      "insert_custom_code": "Indsæt Brugerdefineret kode",
      "show_seats_per_slot": "Vise Pladser pr. tidsrum",
      "allow_reschedule_meeting": "Aktivere Ændre Konferencer",
      "allow_cancelling_meeting": "Aktivere annullering af Konferencer",
      "additional_notes": "Yderligere noter",
      "cancellation_and_reschedule": "Afmelding og Ændre:",
      "allow_staff": "Aktivere personalevalg under booking",
      "code_block_tooltip": "Tredjepartsscripts Indre HTML blokken kan Tilbude kraftig funktionalitet, men de medfører også risici for privatlivets fred, sikkerhed, ydeevne og sideadfærd. Derfor anbefaler vi, at Du til anmeldelse Indhold af denne Kode Før Gemme det til kalenderen.",
      "calendar_image": "Coverbillede af kalenderen",
      "remove_image": "Uddrage Billede",
      "calendar_image_info": "Den uploadede Billede vil være synlig i Gruppe Vis for Neo Skabelon og vises ikke på Link til den individuelle kalender",
      "get_image_from_unsplash": "Forbedr dine billeder med",
      "unsplash": "Unsplash",
      "service_additional_preferences": "Konfigurer Yderligere Indstillinger",
      "service_image": "Coverbillede af service",
      "service_image_description": "Vælg en Billede, der ville være Fremmødte Til menuen Serviceydelser for denne service",
      "allow_reschedule_appointment": "Aktivere Ændre Aftale",
      "allow_cancelling_appointment": "Aktivere annullere Aftale",
      "custom_code_placeholder": "feedback Brugerdefineret kode her",
      "calendar_widget_style_desc": "Vælg den slanke Neo Widget mellem vores klassiske eller",
      "seats_per_slot": "Pladser pr. . tidsrum",
      "show_staff_selection": "Udvalg af personale",
      "seats_per_slot_desc": " Aktive Booker til Vis nummer af tilgængelige Pladser pr. Tidsramme direkte Til kalender- Widget.",
      "show_staff_selection_desc": "Aktivere Booker for at vælge en medarbejdersmedlemmer direkte Fra kalender- Widget under Aftale-booking. Fungerer kun med Neo Widget",
      "widget_re_order_tooltip": "Klassisk Widget stilen gør ikke Aktivere Widget Sortere dynamisk. Sørg for, at Dato Datovælger er første, og at formularen er anden, før du vælger den klassiske stil.",
      "show_staff_selection_desc_service": "Aktivere Booker for at vælge en medarbejdersmedlemmer direkte Fra kalender- Widget under Aftale-booking.",
      "switch_to_classic_widget": "Skift til Klassisk Widget",
      "switch_to_classic_widget_desc": "Dynamisk til <b>Klassisk Widget</b> deaktiverer automatisk Efterfølgende Indstillinger, da de ikke kan eksistere side om side:",
      "form_first_disabled": "<b>Formularen flyttes til anden Trin</b> in Widget -sorteringen.",
      "appointment_preference_disabled": "<b>Ny præference for aftale (book altid med {contactLabel}s tildelte bruger)</b> vil blive deaktiveret. Dette betyder, at aftaler kan bookes med ethvert tilgængeligt gruppemedlem i stedet for at være begrænset til den {contactLabel}s tildelte bruger.",
      "multiple_location_disabled": "<b>Flere Konferencer-adresser</b> vil være Slettet, og kun den <b>først tilføjede placering</b> vil blive bevaret.",
      "insert_custom_code_tooltip": "Tilpas Widget -styling Via din egen CSS kode",
      "classic_tooltip_disabled": "Klassisk widget understøttes ikke til kalendere for klassebookinger",
      "show_staff_selection_disabled_tooltip": "Personaleudvælgelse understøttes kun for neo-widget"
    },
    "roomsAndEquipments": {
      "title": "Vælge Rum og Udstyr",
      "description": "Vælge Fra a Liste af Rum og Udstyr, hvad der vil blive booket sammen med denne kalender",
      "rooms": "Vælge Rum",
      "equipments": "Vælge Udstyr"
    }
  },
  "activity_log": {
    "activity_log": "Aktivitetslog",
    "date": "Dato",
    "filter_by": "Filtrer efter",
    "calendar_update": "Opdatering af kalenderen",
    "start_time_update": "Opdatering af starttidspunkt",
    "end_time_update": "Opdatering af sluttidspunkt",
    "title_update": "Opdatering af titel",
    "notes_update": "Opdatering af noter",
    "appointment_status_update": "Opdatering af aftalestatus",
    "meeting_location_update": "Opdatering af mødested",
    "google_sync_update": "Opdatering af Google Sync",
    "outlook_sync_update": "Opdatering af Outlook Sync",
    "assigned_user_update": "Opdatering af tildelt bruger",
    "appointment_status": "Status for aftalen",
    "assigned_user": "Tildelt bruger",
    "uploaded_to": "Uploadet til",
    "cancelled": "Aflyst",
    "edited": "redigeret",
    "other_edits": "Andre redigeringer",
    "view_details": "Vis oplysninger",
    "all": "Alle"
  },
  "appointment_list": {
    "group_all": "ALLE",
    "group_primary": "PRIMÆR",
    "group_user": "BRUGERE",
    "group_team": "GRUPPER",
    "group_calendar": "KALENDERE",
    "all_appointments": "Alle aftaler",
    "my_calendar": "Min kalender",
    "status_all": "Alle",
    "status_confirmed": "Bekræftet",
    "status_new": "Ny (handling påkrævet)",
    "status_show": "Fremmødt",
    "status_no_show": "Udeblevet",
    "status_cancelled": "Aflyst",
    "status_invalid": "Ugyldig",
    "filter_date_added_desc": "Dato tilføjet (faldende)",
    "filter_start_added_desc": "Startdato (faldende)",
    "filter_start_added_asc": "Startdato stigende fra i dag",
    "button_new_appointment": "Ny aftale",
    "name": "Navn",
    "title": "Titel",
    "requested_time": "Ønsket tid",
    "date_added": "Dato tilføjet",
    "calendar": "Kalender",
    "appointment_owner": "Ejer af aftale",
    "notes": "Noter",
    "status": "Status",
    "action_view_detail": "Vis oplysninger",
    "action_view_consent": "Se samtykke",
    "action_view_notes": "Vis noter",
    "action_edit": "Rediger",
    "action_delete": "Slet",
    "action_reschedule": "Ændr",
    "page_previous": "Tidligere",
    "page_next": "Næste",
    "appointment_notes": "Noter til aftaler",
    "close": "Luk",
    "confirm_delete_header": "Slet aftale",
    "confirm_delete_message": "Er du sikker på, at du vil slette denne aftale?  Denne handling kan ikke fortrydes!",
    "confirm_delete_button": "Slet",
    "confirm_update_header": "Opdater status for aftalen",
    "confirm_update_confirmed_message": "Er du sikker på, at du vil markere denne aftale som bekræftet?",
    "confirm_update_invalid_message": "Er du sikker på, at du vil markere denne aftale som ugyldig?",
    "confirm_update_showed_message": "Er du sikker på, at du vil markere denne aftale som fremmødt?",
    "confirm_update_noshow_message": "Er du sikker på, at du vil markere denne aftale som udeblevet?",
    "confirm_update_cancelled_message": "Er du sikker på, at du vil markere denne aftale som annulleret?",
    "confirm_update_button": "Opdater",
    "empty_state_title": "Der blev ikke fundet nogen aftaler",
    "empty_state_description": "Der blev ikke fundet nogen aftaler",
    "disable_menu_warning": "I øjeblikket har du ikke tilladelse til at se eller redigere aftaleoplysningerne, da den tilknyttede kontakt ikke er tildelt dig. Kontakt din admin for at få yderligere hjælp.",
    "no_contact_warning": "Du kan ikke få adgang til kontaktoplysninger i øjeblikket. Dette kan skyldes, at kontakten ikke er tildelt dig. Kontakt din admin for at få hjælp.",
    "consent_label": "Samtykke",
    "ip_address": "IP",
    "youre_viewing_in": "Vises i øjeblikket i",
    "appointment_delete_msg": "<b>Bemærk:</b> Den aftale, der er slettet herfra, vil ikke blive slettet fra Calendly.",
    "rescheduled": "Ændret"
  },
  "add_guest": {
    "guest_label": "Gæst(er)",
    "search_placeholder": "Søge Fra Venner",
    "add_new": "Tilføj ny",
    "save": "Arkiv",
    "close": "Luk",
    "name": "Navn",
    "phone": "Telefon",
    "email": "E-mail",
    "guest_label_count": "Gæst(s) Optælling",
    "guest_count_error": "Gæst Optælling skal være mellem 1 og 100"
  },
  "languages": {
    "danish": "Danish",
    "dutch": "Dutch",
    "english": "English",
    "finnish": "Finnish",
    "french": "French",
    "french_canada": "French (Canada)",
    "german": "German",
    "hungarian": "Hungarian",
    "italian": "Italian",
    "norwegian": "Norwegian",
    "polish": "Polish",
    "portuguese_brazil": "Portuguese (Brazil)",
    "portuguese_portugal": "Portuguese (Portugal)",
    "spanish": "Spanish",
    "swedish": "Swedish",
    "turkish": "Turkish"
  },
  "service_menu_advanced": {
    "new_service_menu_details_header": "Oplysninger om servicemenu",
    "select_groups_header": "Vælge Serviceydelser",
    "arrange_groups_header": "Konfigurer din Serviceydelser",
    "new_service_menu": "ny Servicemenu",
    "service_menu_sub_title": "Åbn en Tilpasset servicemenu til din Kunder in kun få klik",
    "quick_tip": "Du kan Inkludere Gruppe til servicemenu",
    "service_menu_name": "Navn på servicemenu",
    "service_menu_description": "Beskrivelse",
    "service_menu_slug": "URL til service",
    "select_groups_calendars": "Vælge gruppe og kalendere",
    "select_groups_calendars_desc": "Tilføj Serviceydelser til din servicemenu",
    "select_all": "Vælge hver",
    "arrange_groups": "Konfigurer Sortere af Serviceydelser",
    "arrange_groups_desc": "Bestem Proces af Serviceydelser Til servicemenuen",
    "arrange_services_quicktip": "For at Ændre kalendere i Gruppe skal du gå til Gruppe > Valgmuligheder > Ændre Kalendere.",
    "enable_add_guest_desc": "Aktivere Kunder at Inkludere yderligere gæster, når du foretager en booking.",
    "enable_multiple_service_desc": "Aktivere Kunder til at Book flere Serviceydelser in en individuel Aftale.",
    "enable_staff_selection_desc": "Aktivere Kunder til at vælge foretrukket personale Medlemmer Når du booker.",
    "enable_add_guest": "Aktivere Tilføj gæster",
    "enable_multiple_service": "Aktivere valg af flere serviceydelser",
    "enable_staff_selection": "Aktivere valg af personale",
    "additional_options": "Yderligere Valgmuligheder",
    "code_block_tooltip": "Tredjepartsscripts Indre HTML blokken kan Tilbude kraftig funktionalitet, men de medfører også risici for privatlivets fred, sikkerhed, ydeevne og sideadfærd. Derfor anbefaler vi, at Du til anmeldelse Indhold af denne Kode Før Gemme den til servicemenuen.",
    "custom_code_placeholder": "feedback Brugerdefineret kode her",
    "insert_custom_code": "Indsæt Brugerdefineret kode",
    "no_service": "Der blev ikke fundet nogen service",
    "no_service_desc": " Ingen Serviceydelser fundet. Opret Serviceydelser og Inkludere dem til Gruppe for at Opret en servicemenu.",
    "learn_more": "Få mere at vide",
    "no_service_selected": "Ingen service Valgt",
    "create_service_calendars": "Opret servicekalendere",
    "alert_description": " in Sortere til Oprets servicemenu, skal du Opret servicere kalendere og inkludere dem i Gruppe",
    "dont_show_again": "Vis ikke dette igen",
    "service_name_required": "Navn på servicemenuen er Påkrævet",
    "slug_already_taken": "Denne Slug er allerede taget",
    "slug_required": "Slug er Påkrævet",
    "please_enter_name": "Indtast et navn",
    "service_name_placeholder": "PRIMÆR Menu",
    "service_slug_placeholder": "hovedmenu",
    "form_label": "Formular",
    "consent_label": "Samtykke Afkrydsningsfelt",
    "consent_input_placeholder": "Tilføj Samtykke Indhold",
    "consent_tooltip": "Aktivér denne indstilling for at tillade indhentning af samtykke fra {contactsLabel}, når de angiver deres telefonnummer under aftalebookingprocessen.",
    "back_message": "Tilbage til Liste",
    "saving_changes": "Kun et minut — Gemme den seneste Dynamisk ...",
    "payment_provider_warning": "Bemærk! Servicemenuer understøtter i øjeblikket kun betalinger via Stripe og Authorize.net. Da din standardudbyder afviger, vil betalingsopkrævning for valgte kalendere med aktiverede betalinger blive sprunget over.",
    "aria": {
      "consent_form_toggle": "Aktivér samtykkeformular",
      "enable_add_guest_toggle": "Aktivér tilføj gæst",
      "enable_multiple_services_toggle": "Aktivér flere tjenester",
      "enable_staff_selection_toggle": "Aktivér valg af personale"
    }
  },
  "widget_configuration": {
    "customise_calendar_widget": "Tilpas-kalender- Widget",
    "works_with_neo_widget": "Fungerer kun med Neo Widget",
    "customise_widget_desc": "Tilpas Widget Udseende: PRIMÆR Farve, Baggrund Farve og Knap Indhold.",
    "learn_more": "Få mere at vide",
    "primary_settings": "PRIMÆR Indstillinger",
    "primary_settings_desc": "Konfigurer PRIMÆR Farve, Baggrund Farve og Andet Widget Indstillinger for at Tilpas din kalender- Widget",
    "primary_color": "PRIMÆR Farve",
    "primary_color_desc": "Definer Farve for Knap, datoer, Dato-tidsrum og aktiviteter",
    "background_color": "Baggrund Farve",
    "background_color_desc": "Samling af Baggrund Farve, der fungerer som baggrund for både datotime og Formular.",
    "button_text": "Knap Indhold",
    "button_text_desc": "Tilpas the Indhold vist Til the Knap Når booking en Aftale",
    "calendar_title": "Kalenderens Titel",
    "calendar_title_desc": "Navnet på din kalender",
    "calendar_description": "Beskrivelse",
    "calendar_description_desc": "Den indtastede Beskrivelse",
    "calendar_details": "Oplysninger",
    "calendar_details_desc": "Inkluderer Oplysninger som Varighed, Dato & Dato, Tilbagevendende Oplysninger og tidszone",
    "reset_to_default": "Nulstille til Standard",
    "preview_widget": "Widget til Forhåndsvisning",
    "calendar_title_tooltip": "Samling Hvis Kalendernavn og gruppenavn (hvis det er relevant) skal være synlige frem til Booking-widgeten.",
    "calendar_description_tooltip": "Samling Hvis Kalenderbeskrivelsen skal være synlig indtil Booking-widgetten.",
    "calendar_details_tooltip": "Samling Hvis de Vigtige møder Oplysninger som Konferencer Varighed, Valgt Dato & Dato og gentagelsesinfo (hvis det er relevant) skal være synlige frem til Booking-widgeten.",
    "insert_custom_code_tooltip": "Tilpas Widget -styling Via din egen CSS kode.",
    "staff_selection_tooltip": "Aktivere Booker for at vælge en medarbejdersmedlemmer direkte Fra kalender- Widget under Aftale-booking. Fungerer kun med Neo Widget."
  },
  "eventNotification": {
    "customFields": "Tilpasset Felter",
    "customValues": "Brugerdefinerede værdier",
    "guest": "Gæst",
    "assignedUser": "Tildelt bruger",
    "additionalEmails": "Yderligere e-mailadresser",
    "list": {
      "booked": {
        "title": "Aftale booket (Status: ubekræftet)",
        "note": "Denne meddelelse sendes, når der oprettes en ny aftale med statussen Ubekræftet.",
        "subTitle": "Giver besked, når en aftale er booket med en ubekræftet status"
      },
      "confirmation": {
        "title": "Aftale booket (Status: bekræftet)",
        "note": "Denne meddelelse sendes, når der oprettes en aftale med eller opdateres til statussen Bekræftet.",
        "subTitle": "Giver besked, når en aftale er blevet bekræftet"
      },
      "cancellation": {
        "title": "Annullering",
        "note": "Denne meddelelse sendes, når en aftale annulleres, markeres som udeblevet eller markeres som ugyldig.",
        "subTitle": "Advarer om, at en aftale er blevet aflyst"
      },
      "reschedule": {
        "title": "Ændr",
        "note": "Denne notifikation sendes, når en Aftale omlægges. Den udløses kun, hvis Aftale in Status ubekræftet eller Bekræftet.",
        "subTitle": "Giver besked, når en aftale ændres"
      },
      "reminder": {
        "title": "Påmindelse",
        "note": "Denne Notifikation sendes som en Påmindelse Før the Aftale. Den udløses kun, hvis Aftale in Status ubekræftet eller Bekræftet.",
        "subTitle": "Sender en påmindelse før aftalen."
      },
      "followup": {
        "title": "Opfølgning",
        "note": "Denne meddelelse sendes efter aftalen som en opfølgning. Det udløses kun, hvis aftalen har statussen Ubekræftet, Bekræftet eller Fremmødt.",
        "subTitle": "Sender en opfølgende besked efter aftalen er gennemført"
      }
    },
    "saveToastMsg": "Indstillingerne blev gemt!",
    "saveToastMsgDesc": "Dine ændringer er blevet gemt",
    "enableSuccess": "Påmindelse Aktiveret!",
    "disableSuccess": "Påmindelse Deaktiveret!",
    "tooltip": "Denne meddelelse er blevet deaktiveret. Aktivér den for at foretage eventuelle ændringer.",
    "enabled": "Aktiveret",
    "disabled": "Deaktiveret",
    "statusLabel": "Statusmærker",
    "email": {
      "channelName": "E-mail",
      "noneTemplate": "Ingen",
      "notificationLabel": "Hvem skal modtage denne notifikation?",
      "sendButtonLabel": "Send test-e-mail",
      "testEmailLabel": "Test-e-mail",
      "testEmailPlaceholder": "Indtast modtagerens e-mailadresse til testformål",
      "body": "E-mailbrødtekst",
      "bodyPlaceholder": "Skriv din besked her",
      "subject": "Emne",
      "subjectPlaceholder": "Indtast e-mailens emne",
      "templateLabel": "E-mailskabelon",
      "templatePlaceholder": "Vælg en e-mailskabelon, eller start fra bunden",
      "fromNamePlaceholder": "Indtast navn",
      "fromNameLabel": "Fra Navn",
      "fromAddressLabel": "Fra Adresse",
      "alertEmailAddress": "Indtast e-mail-id'er (Adskilt Via komma)",
      "addMore": "Tilføj mere",
      "afterAppointmentEnds": "efter aftalen slutter",
      "beforeAppointmentStarts": "før aftalen begynder",
      "durationLabel": "Hvornår vil du udløse notifikationen?",
      "disableEmailNotification": "Deaktiver e-mailnotifikationer",
      "enableEmailNotification": "Aktivér e-mailnotifikationer",
      "enableSuccess": "E-mailnotifikation aktiveret!",
      "enableSuccessDesc": "Du vil nu begynde at modtage denne notifikation",
      "disableSuccess": "E-mail-notifikation er deaktiveret!",
      "disableSuccessDesc": "Du vil ikke længere modtage denne notifikation",
      "reset_to_default": "Nulstille til Standard",
      "testEmailSuccessTitle": "Testmail sendt!",
      "testEmailSuccessDesc": "En testmail er blevet sendt til {email}",
      "testEmailErrorTitle": "Kunne ikke sende testmail",
      "testEmailErrorDesc": "Der opstod en fejl under afsendelse af testmailen. Prøv igen."
    },
    "inApp": {
      "channelName": "I appen",
      "title": "Notifikationsindstillinger",
      "enableInAppNotification": "Aktivér notifikationer i appen",
      "disableInAppNotification": "Deaktiver notifikationer i appen",
      "selectedUser": {
        "label": "Send til",
        "helperText": "Denne interne notifikation sendes via web-apps og mobile apps",
        "placeholder": "Vælg bruger(e)"
      },
      "enableSuccess": "App-notifikationer aktiverede!",
      "enableSuccessDesc": "Du vil nu begynde at modtage denne notifikation",
      "disableSuccess": "App-notifikationer deaktiverede!",
      "disableSuccessDesc": "Du vil ikke længere modtage denne notifikation"
    },
    "sms": {
      "channelName": "SMS",
      "noneTemplate": "Ingen",
      "notificationLabel": "Hvem skal modtage denne notifikation?",
      "sendButtonLabel": "Send test-SMS",
      "testSMSLabel": "Test-sms (indtast telefonnummer med landekode)",
      "testSMSPlaceholder": "+12345678901",
      "body": "SMS-besked",
      "bodyPlaceholder": "Skriv din SMS-besked her",
      "durationLabel": "Hvornår vil du udløse notifikationen?",
      "disableSMSNotification": "Deaktiver SMS-notifikationer",
      "enableSMSNotification": "Aktivér SMS-notifikationer",
      "enableSuccess": "SMS-notifikation aktiveret!",
      "enableSuccessDesc": "Du vil nu begynde at modtage denne notifikation",
      "disableSuccess": "SMS-notifikation deaktiveret!",
      "disableSuccessDesc": "Du vil ikke længere modtage denne notifikation",
      "alertPhoneNumbers": "Indtast telefonnumre (med landekoder adskilt af kommaer)",
      "alertPhoneNumbersPlaceholder": "+12345678901, +447123456789",
      "addMore": "Tilføj flere",
      "afterAppointmentEnds": "når aftalen slutter",
      "beforeAppointmentStarts": "før aftalen begynder",
      "templateLabel": "SMS-skabelon",
      "templatePlaceholder": "Vælg SMS-skabelon...",
      "reset_to_default": "Nulstil til standard",
      "testSmsSuccessTitle": "Test-SMS sendt!",
      "testSmsSuccessDesc": "En test-SMS er blevet sendt til {phone}",
      "testSmsErrorTitle": "Kunne ikke sende test-SMS",
      "testSmsErrorDesc": "Der opstod en fejl under afsendelse af test-SMS'en. Prøv igen."
    },
    "whatsapp": {
      "channelName": "WhatsApp",
      "notificationLabel": "Hvem skal modtage denne notifikation?",
      "sendButtonLabel": "Send testnotifikation via WhatsApp",
      "testWhatsAppLabel": "Test WhatsApp-notifikation (indtast telefonnummer med landekode)",
      "testWhatsAppPlaceholder": "+12345678901",
      "durationLabel": "Hvornår vil du udløse notifikationen?",
      "alertPhoneNumbers": "Indtast telefonnumre (med landekoder adskilt af kommaer)",
      "alertPhoneNumbersPlaceholder": "+12345678901, +447123456789",
      "addMore": "Tilføj flere",
      "afterAppointmentEnds": "når aftalen slutter",
      "beforeAppointmentStarts": "før aftalen begynder",
      "templateLabel": "WhatsApp-skabelon",
      "templatePlaceholder": "Vælg WhatsApp-skabelon...",
      "noPreview": "Ingen skabelon er valgt",
      "templateRequired": "Skabelon er påkrævet",
      "testWhatsAppSuccessTitle": "Testnotifikation via WhatsApp sendt!",
      "testWhatsAppSuccessDesc": "En testnotifikation via WhatsApp er blevet sendt til {phone}",
      "testWhatsAppErrorTitle": "Kunne ikke sende testnotifikation via WhatsApp",
      "testWhatsAppErrorDesc": "Der opstod en fejl under afsendelse af testnotifikationen via WhatsApp. Prøv igen.",
      "setupTitle": "Kontakt din kunde på vedkommendes foretrukne besked-app",
      "setupDescription": "Hold kontakten med dine kunder ved at levere øjeblikkelig support, sende rettidige opdateringer og skabe engagerende interaktioner.",
      "connectWhatsApp": "Forbind WhatsApp",
      "checkingStatus": "Kontrollerer WhatsApp-kontoens status...",
      "checkingTemplateStatus": "Kontrollerer WhatsApp-skabelonstatus...",
      "statusCheckError": "Det lykkedes ikke at kontrollere WhatsApp-kontoens status",
      "templateStatusCheckError": "Det lykkedes ikke at kontrollere WhatsApp-skabelonens status",
      "setupTemplateTitle": "Afslutte din WhatsApp Skabelon Konfig",
      "setupTemplateDescription": "Du skal Konfigurer WhatsApp-skabeloner, Før du kan Upload notifikationer. Klik nedenfor for at fuldføre opsætningsprocessen.",
      "loadTemplatesError": "Det lykkedes ikke at indlæse WhatsApp-skabeloner",
      "templatesRefreshed": "Skabelonerne er blevet opdateret",
      "templatesRefreshError": "Kunne ikke opdatere skabeloner",
      "templatesResolveError": "Det lykkedes ikke at løse WhatsApp-standardskabeloner",
      "locationNotFound": "Placerings-id blev ikke fundet",
      "settingsRedirectError": "Kan ikke omdirigere til WhatsApp-indstillinger",
      "updateNotificationError": "Kunne ikke opdatere WhatsApp-notifikation",
      "notificationsEnabled": "WhatsApp-notifikationer aktiveret!",
      "notificationsDisabled": "WhatsApp-notifikationer deaktiveret!",
      "updateError": "Fejl ved opdatering af notifikationer",
      "createNewTemplate": "Opret ny WhatsApp-skabelon",
      "phoneValidation": {
        "countryCodeRequired": "Telefonnummeret skal starte med en landekode (f.eks. +1, +91, +44)",
        "digitsOnly": "Telefonnummer må kun indeholde cifre efter landekoden",
        "tooShort": "Telefonnummeret er for kort",
        "tooLong": "Telefonnummeret er for langt",
        "invalid": "Ugyldigt telefonnummer"
      },
      "errors": {
        "templateNotFound": "Skabelon-id blev ikke fundet i indlæste valgmuligheder, rydder",
        "templateNoLongerValid": "Den gemte skabelon er ikke længere gyldig, rydder",
        "invalidTemplateSelection": "Forsøgte at klikke en udløbet WhatsApp-skabelon",
        "fetchingTemplates": "\"Fejl under hentning af WhatsApp-skabeloner\"",
        "mountingCreator": "Fejl ved montering af WhatsApp-skabelonopretter",
        "fetchingAfterCreation": "Fejl ved hentning af WhatsApp-skabeloner efter oprettelse",
        "updateStatus": "Det lykkedes ikke at med at opdatere WhatsApp-status"
      },
      "receiverLabels": {
        "assignedUser": "Tildelt bruger",
        "phoneNumbers": "Yderligere telefonnumre"
      }
    }
  },
  "smsTemplate": {
    "create_new_template": "Opret ny SMS-skabelon",
    "create_new_template_desc": "Opret en genanvendelig SMS-skabelon til dine notifikationer",
    "template_name": "Skabelonnavn",
    "template_name_placeholder": "Indtast skabelonnavn",
    "message": "Besked",
    "message_placeholder": "Skriv din SMS-besked her",
    "create_template": "Opret skabelon",
    "name_required": "Skabelonnavn er påkrævet",
    "text_required": "Beskedtekst er påkrævet",
    "fetch_new_templates": "Opdater skabeloner"
  },
  "whatsappTemplate": {
    "create_new_template": "Opret ny WhatsApp-skabelon",
    "create_new_template_desc": "Opret en genanvendelig WhatsApp-skabelon til dine notifikationer",
    "template_name": "Skabelonnavn",
    "template_name_placeholder": "Indtast skabelonnavn",
    "message": "Besked",
    "message_placeholder": "Skriv din WhatsApp-besked her",
    "create_template": "Opret skabelon",
    "name_required": "Skabelonnavn er påkrævet",
    "text_required": "Beskedtekst er påkrævet",
    "fetch_new_templates": "Opdater skabeloner"
  },
  "archivedServices": {
    "servicesBanner": "En ny opgraderet Version af Serviceydelser er her—mere kraftfuld, fleksibel og intuitiv. Dine servicekalendere er allerede blevet migreret. Udforsk dem nu in fanen Serviceydelser.",
    "archivedServiceCalendars": "Servicekalendere (v1)",
    "check_new_services": "Flueben ny Serviceydelser"
  },
  "tour": {
    "hidden_test_label": "Test",
    "calendar": {
      "edit_calendar": "Rediger kalender",
      "share_calendar": "Dele kalender",
      "troubleshoot_calendar": "Fejlfind kalender",
      "more_options": "Flere Valgmuligheder",
      "edit_calendar_desc": "Administrer hver kalenderindstillinger—Fast Tilgængelighed, Konfigurer Påmindelse, Ændre Aftale grænser og mere.",
      "share_calendar_desc": "Kopiér og Slet dit Link til planlægning, så Booker nemt kan skema med Du.",
      "troubleshoot_calendar_desc": "Find ud af, hvorfor et tidsrum ikke vises, og se mulige årsager i fejlfindingsvisningen.",
      "more_options_desc": "Få adgang til yderligere indstillinger og aktiviteter til at administrere din kalender.",
      "read_permissions": {
        "share_description": "Giv andre adgang ved at dele kalenderlinket eller justere tilladelserne.",
        "troubleshoot_description": "Identificer og løs problemer som synkroniseringsfejl eller manglende hændelser for at sikre problemfri funktionalitet."
      },
      "next": "Næste",
      "start_over": "Start forfra",
      "all_set": "hver Samling!",
      "previous": "Tidligere"
    }
  },
  "emailTemplate": {
    "select_editing_experience": "Vælge din redigeringsoplevelse",
    "select_editing_experience_desc": "Vælg at bygge Via vores visuelle træk-og-slip- Editor eller kraftige Kodeeditor",
    "design_editor": "Editor",
    "design_editor_desc": "Visuel, Træk og slip-redigering.",
    "code_editor": "Kodeeditor",
    "code_editor_desc": "Funktioner-rig HTML -redigering.",
    "text_editor": "Almindelig Kodeeditor",
    "text_editor_desc": "Enkel, ren, ubesværet Indhold-redigering.",
    "email_text_block": "E-mail kan også oprettes Via Indhold Spær. ",
    "select": "Vælge",
    "new_template": "ny Skabelon",
    "email_block": "E-mail kan også oprettes Via Indhold Spær.",
    "fetch_new_templates": "Hent nye skabeloner"
  },
  "quick_tips": {
    "meeting_details": {
      "include_contact_and_user_names": "For at inkludere både kontaktens navn og aftalebrugerens navn i mødetitlen skal du bruge følgende format: &#123;&#123;contact.name&#125;&#125; X &#123;&#123;appointment.user.name&#125;&#125;",
      "add_backup_meeting_url": "For at sikre uafbrudt adgang skal du tilføje en brugerdefineret møde-URL som en backupmulighed, hvis der opstår problemer med Zoom- eller Gmeet-integrationer.",
      "enable_gmeet_primary": "For at aktivere Gmeet-funktionaliteten skal du sørge for, at teammedlemmets Google Kalender er indstillet som deres primære kalender i indstillingerne."
    },
    "availability": {
      "twenty_four_hours": "For at gøre kalenderen tilgængelig i 24 timer skal du indstille tidsintervallet fra kl. 00 til 00.",
      "update_timezone_preferences": "Tidszoner kan ændres når som helst under Virksomhedsprofil >> Tidszonepræferencer.",
      "service_calendar_slot_interval": "Indstil din servicekalenders tilgængelighed med et standardinterval på 15 minutter mellem aftaler."
    },
    "forms": {
      "create_custom_forms": "Opret nemt brugerdefinerede formularer i Marketing-sektionen under \"Formularer\", og integrer dem problemfrit i kalendere for organiseret dataindsamling.",
      "apply_sticky_contacts": "Når du tilføjer en brugerdefineret formular, anvendes de indstillinger for faste kontakter, der er knyttet til formularen, automatisk.",
      "use_custom_values": "Du har mulighed for at inkludere brugerdefinerede værdier og felter for kontakter i både formularmeddelelsen og formularens URL."
    },
    "notifications": {
      "use_workflows": "Brug Arbejdsgange eller Aftalebookede udløsere for avancerede notifikationer."
    },
    "customizations": {
      "update_widget_language": "For at ændre sprogindstillingerne for widgetten skal du følge disse trin: Indstillinger >> Kalendere >> Præferencer >> Kontoindstillinger."
    },
    "equipments": {
      "room_definition": "Et 'rum' kan repræsentere ethvert sted, hvor tjenester leveres. Dette kunne være fysiske rum og/eller dedikerede stationer. F.eks. pedicurestation.",
      "equipment_definition": "Tænk på 'udstyr' som ethvert værktøj eller enhver enhed, som virksomheder bruger til at opfylde aftaler. Dette kan omfatte maskiner, apparater eller endda stole."
    }
  },
  "aria_labels": {
    "sticky_contacts": "Fastgjorte kontakter",
    "consent_form": "Samtykkeformular",
    "enable_guests": "Aktivér gæster",
    "auto_confirm": "Automatisk bekræftelse",
    "should_accept_payment": "Skal acceptere betaling",
    "collect_deposit": "Indsamling af indbetaling",
    "enable_charge_guests": "Aktivér opkrævning af gæster",
    "enable_coupon": "Aktivér kupon",
    "payment_live": "Live-betaling",
    "add_availability_hour": "Tilføj tilgængelige timer",
    "remove_availability_hour": "Fjern tilgængelige timer",
    "copy_availability_hour": "Kopiér tilgængelige timer",
    "close_modal": "Luk modalvindue",
    "add_custom_slot": "Tilføj tilpasset tidsrum",
    "remove_custom_slot": "Fjern tilpasset tidsrum",
    "edit_custom_slot": "Rediger tilpasset tidsrum",
    "update_frequency": "Opdateringsfrekvens",
    "show_calendar_title": "Vis kalendertitel",
    "show_calendar_description": "Vis kalenderbeskrivelse",
    "show_calendar_details": "Vis kalenderoplysninger",
    "allow_reschedule": "Tillad ændring af tid",
    "allow_cancellation": "Aktivér annullering",
    "category_actions": "Kategorihandlinger"
  },
  "placeholders": {
    "pixel_id": "Pixel-id",
    "select_one": "Vælg en",
    "meeting_location": "Mødested",
    "schedule_meeting": "Planlæg møde",
    "notes": "Noter",
    "select_users": "Vælg brugere"
  },
  "alt_text": {
    "payment_provider": "Betalingsudbyder",
    "no_calendars": "Ingen kalendere",
    "date_specific_hours": "datospecifikke-timer",
    "custom_widget_image": "Tilpasset widget-billede",
    "service_calendar": "Bookingkalender",
    "event_calendar": "Begivenhedskalender",
    "round_robin_booking": "Booking med automatisk tildeling af aftaler",
    "class_booking": "Holdbooking",
    "collective_booking": "Kollektiv booking"
  },
  "tooltips": {
    "text_color": "Tekstfarve",
    "background_color": "Baggrundsfarve",
    "strikethrough": "Gennemstreget tekst",
    "superscript": "Hævet skrift",
    "subscript": "Sænket skrift",
    "inline_code_block": "Indbygget kodemodul",
    "code_block": "Kodemodul",
    "block_quote": "Modulcitat",
    "more": "Mere",
    "upload": "Upload"
  },
  "labels": {
    "reset_style": "Nulstil stil",
    "reset_document_style": "Nulstil dokumentets stil",
    "source_code": "Kildekode",
    "success": "Gennemført",
    "edit": "Rediger",
    "submit": "Indsend",
    "cancel": "Annuller",
    "payment": "Betaling",
    "here_is_the_link": "Her er linket:",
    "here_is_the_embed_code": "Her er indlejringskoden:",
    "service_calendar": "Bookingkalender",
    "collective_booking": "Kollektiv booking",
    "class_booking": "Holdbooking",
    "round_robin_booking": "Booking med automatisk tildeling af aftaler",
    "event_calendar": "Begivenhedskalender",
    "personal_booking": "Personlig booking",
    "service_booking": "Servicebooking"
  },
  "validation_messages": {
    "calendar_group_name_required": "Kalendergruppens navn er påkrævet",
    "calendar_group_description_required": "Beskrivelsen af kalendergruppen er påkrævet",
    "slug_required": "Slug er påkrævet",
    "slug_not_valid": "Denne slug er ugyldig",
    "slug_already_taken": "Denne slug er allerede optaget",
    "error_validating_slug": "Fejl ved validering af slug",
    "please_enter_name": "Indtast et navn",
    "room_name_required": "Navn på rum er påkrævet",
    "equipment_name_required": "Udstyrets navn er påkrævet",
    "subject_required": "Emne er påkrævet",
    "this_is_required": "Dette er påkrævet",
    "calendar_group_slug_required": "Kalendergruppens slug er påkrævet",
    "capacity_mandatory": "Kapacitet er påkrævet",
    "capacity_cannot_be_zero": "Kapaciteten må ikke være nul",
    "capacity_should_be_a_number": "Kapaciteten skal være et tal",
    "capacity_cannot_be_negative": "Kapaciteten må ikke være negativ",
    "capacity_should_be_a_whole_number": "Kapaciteten skal være et helt tal",
    "quantity_mandatory": "Mængde er påkrævet",
    "quantity_cannot_be_zero": "Mængden må ikke være nul",
    "quantity_should_be_a_number": "Mængden skal være et tal",
    "quantity_cannot_be_negative": "Mængden må ikke være negativ",
    "quantity_should_be_a_whole_number": "Mængden skal være et helt tal",
    "quantity_cannot_be_less_than_out_of_service_equipments": "Mængden må ikke være mindre end antal udstyrsenheder, der er ude af drift",
    "out_of_service_value_should_be_a_number": "Værdien for ude-af-drift skal være et tal",
    "out_of_service_cannot_be_negative": "Ude-af-drift må ikke være negativ",
    "out_of_service_equipments_qty": "Udstyr, der er ude af drift, må ikke overstige den faktiske mængde udstyr",
    "out_of_service_whole_number": "Ude-af-drift skal være et helt tal",
    "slot_duration_required": "Tidsrummets varighed er påkrævet",
    "slot_duration_integer": "Tidsrummets varighed skal være et helt tal",
    "meeting_duration_validation": "Mødets varighed skal være mellem 1 minut og 12 timer",
    "seats_class_required": "Pladser pr. klasse er påkrævet",
    "seats_class_integer": "Pladser pr. klasse skal være et helt tal",
    "seats_class_validation": "Dette må ikke være større end 9999 eller mindre end 0",
    "meeting_location_required": "Mødested er påkrævet"
  },
  "custom_values": {
    "assigned_user": "Tildelt bruger",
    "full_name": "Fulde navn",
    "first_name": "Fornavn",
    "last_name": "Efternavn",
    "email": "E-mail",
    "phone": "Telefonnummer",
    "twilio_phone": "Twilio-telefon",
    "account": "Konto",
    "name": "Navn",
    "full_address": "Fuld adresse",
    "city": "By",
    "state": "Stat",
    "country": "Land",
    "postal_code": "Postnummer",
    "contact": "Kontakt",
    "address1": "Adresse 1",
    "timezone": "Tidszone",
    "user": "Bruger",
    "appointment": "Aftale",
    "start_date_time": "Startdato og tid",
    "start_date": "Startdato",
    "start_time": "Starttidspunkt",
    "end_date_time": "Slutdato og tidspunkt",
    "end_date": "Slutdato",
    "end_time": "Sluttidspunkt",
    "meeting_location": "Mødested"
  },
  "meeting_location_types": {
    "zoom": "Zoom",
    "google_meet": "Google Meet",
    "phone": "Telefonnummer",
    "full_address": "Fuld adresse",
    "microsoft_teams": "Microsoft Teams",
    "custom": "Tilpasset"
  },
  "duration_units": {
    "minutes": "Minutter",
    "hours": "Timer"
  },
  "widget_styles": {
    "classic": "Klassisk",
    "neo": "Neo"
  },
  "feature_labels": {
    "service_menu": "Servicemenu",
    "rooms": "Rum",
    "equipments": "Udstyr"
  },
  "lsa": {
    "categories": {
      "accountant": "Bogføring",
      "acupuncturist": "Akupunktur",
      "air_duct_cleaner": "Rensning af ventilationskanaler",
      "alcohol_treatment": "Behandling af alkoholisme",
      "animal_shelter": "Dyreredningstjenester",
      "appliance_repair": "Reparation af apparater",
      "architect": "Arkitektur",
      "assisted_living": "Plejehjem",
      "babysitter": "Børnepasning",
      "bankruptcy_lawyer": "Konkurslovgivning",
      "beauty_school": "Skønhedsskole",
      "business_lawyer": "Erhvervsret",
      "car_repair": "Bilservice",
      "carpenter": "Tømrerarbejde",
      "carpet_cleaning": "Tæpperens",
      "child_care": "Børnepasningstjenester",
      "chiropractor": "Kiropraktiske tjenester",
      "cleaning_service": "Rengøring af hus",
      "contract_lawyer": "Kontraktlovgivning",
      "countertop_pro": "Bordpladeservice",
      "criminal_lawyer": "Strafferet",
      "dance_instructor": "Danseinstruktion",
      "disability_lawyer": "Handicaplovgivning",
      "driving_instructor": "Køreundervisning",
      "dui_lawyer": "Lov om spirituskørsel",
      "electrician": "Elektrisk",
      "energy_efficiency_pro": "Energieffektivitetstjenester",
      "estate_lawyer": "Ejendomsret",
      "event_planner": "Eventplanlægning",
      "family_lawyer": "Familieret",
      "fencing_pro": "Indhegning",
      "financial_planner": "Finansiel planlægning",
      "first_aid_trainer": "Førstehjælpskurser",
      "flooring_pro": "Gulvbelægning",
      "foundation_pro": "Fundamenter",
      "funeral_home": "Begravelsestjenester",
      "garage_door_pro": "Garageport",
      "general_contractor": "Boligrenovation",
      "handyman": "Handyman",
      "home_inspector": "Inspektion af hjemmet",
      "home_security": "Sikkerhedstjenester i hjemmet",
      "home_theater": "Hjemmebiograftjenester",
      "hvac": "HVAC",
      "immigration_lawyer": "Immigrationslov",
      "interior_designer": "Indretningsdesign",
      "ip_lawyer": "Intellektuel ejendomsret",
      "junk_removal": "Fjernelse af affald",
      "labor_lawyer": "Arbejdsret",
      "landscaper": "Landskabsdesign",
      "language_instructor": "Sprogundervisning",
      "lawn_care": "Plænepleje",
      "litigation_lawyer": "Retssager",
      "locksmith": "Låsesmed",
      "malpractice_lawyer": "Lov om fejlbehandling",
      "massage_center": "Massagebehandlinger",
      "massage_school": "Massageskole",
      "mover": "Flytter",
      "nursing_home": "Plejehjemsservice",
      "painter": "Maleri",
      "personal_injury_lawyer": "Lov om personskade",
      "personal_trainer": "Personlig træning",
      "pest_control": "Skadedyrskontrol",
      "pet_adoption": "Kæledyrsadoptionstjenester",
      "pet_boarding": "Dyrepension",
      "pet_grooming": "Kæledyrspleje",
      "pet_trainer": "Kæledyrstræning",
      "photographer": "Fotografi",
      "plumber": "Blikkenslagerarbejde",
      "pool_cleaner": "Poolrensning",
      "pool_contractor": "Poolentreprise",
      "preschool": "Indskoling",
      "psychologist": "Psykologarbejde",
      "real_estate_agent": "Ejendomsbranchen",
      "real_estate_lawyer": "Ejendomsret",
      "rehab": "Rehabiliteringstjenester",
      "roofer": "Tagdækning",
      "sewage_pro": "Kloakservice",
      "siding_pro": "Beklædning",
      "smart_home": "Smart Home-serviceydelser",
      "snow_removal": "Snerydningstjenester",
      "spa": "Spa-behandlinger",
      "tax_lawyer": "Skatteret",
      "tax_specialist": "Skattetjenester",
      "therapist": "Terapi",
      "towing_pro": "Vejhjælp",
      "traffic_lawyer": "Færdselslov",
      "tree_service": "Træarbejde",
      "tutor": "Undervisning",
      "upholstery_cleaner": "Rengøring af møbelbetræk",
      "veterinarian": "Dyrlægeydelser",
      "videographer": "Videotjenester",
      "water_damage": "Service til vandskader",
      "weight_loss_service": "Vægttab",
      "window_cleaner": "Vinduespudsning",
      "window_repair": "Vinduesservice",
      "windshield_repair_pro": "Autoglas",
      "yoga_instructor": "Yoga"
    },
    "job_types": {
      "accountant_other": "Andet",
      "bankruptcy_tax_litigation": "Retssager om konkurs og skat",
      "bookkeeping": "Bogføring",
      "business_consulting": "Virksomhedsrådgivning",
      "debt_collection_relief": "Inkassohjælp",
      "irs_representation_resolution": "IRS-repræsentation og -løsning",
      "payroll": "Lønningsliste",
      "tax_planning_business": "Skatteplanlægningsvirksomhed",
      "tax_planning_individual": "Skatteplanlægning for enkeltpersoner",
      "tax_return_business": "Skatteopgørelse for virksomhed",
      "tax_return_individual": "Skatteopgørelse for enkeltperson",
      "trusts_estates_accounting": "Regnskab for fonde og dødsboer",
      "acupressure": "Akupressur",
      "acupuncture": "Akupunktur",
      "acupuncturist_other": "Andet",
      "cupping": "Cupping",
      "gua_sha": "Gua Sha",
      "heat_therapy": "Varmeterapi",
      "herbal_therapy": "Urteterapi",
      "infrared_therapy": "Infrarød terapi",
      "moxibustion": "Moxibustion",
      "qigong": "Qigong",
      "shiatsu": "Shiatsu",
      "tui_na": "Tui Na",
      "air_duct_cleaning": "Rensning af ventilationskanaler",
      "air_duct_filter_replacement": "Filterudskiftning",
      "air_duct_other": "Andet",
      "dryer_vent_cleaning": "Rengøring af tørretumblerens udtræk",
      "furnace_cleaning": "Rengøring af fyr",
      "indoor_air_quality_testing": "Indendørs luftkvalitetstest",
      "alcohol_treatment_other": "Andet",
      "animal_shelter_cat_adoption": "Adoption af katte",
      "animal_shelter_dog_adoption": "Adoption af hunde",
      "animal_shelter_other": "Andet",
      "animal_shelter_other_animal_adoption": "Adoption af andet dyr",
      "animal_shelter_other_veterinary_services": "Andre veterinære serviceydelser",
      "animal_shelter_spay_neuter": "Sterilisering eller kastrering",
      "animal_shelter_vaccinations": "Vaccinationer",
      "lost_stray_found_animals": "Mistede, herreløse eller fundne dyr",
      "pet_license": "Kæledyrslicens",
      "pet_surrender": "Aflevering af kæledyr",
      "appliance_other": "Andet",
      "repair_dishwasher": "Reparation af opvaskemaskine",
      "repair_dryer": "Reparation af tørretumbler",
      "repair_freezer": "Reparation af fryser",
      "repair_microwave": "Reparation af mikrobølgeovn",
      "repair_oven": "Reparation af ovn",
      "repair_refrigerator": "Reparation af køleskab",
      "repair_refrigerator_freezer": "Reparation af køleskab/fryser",
      "repair_stove_cooktop": "Reparation af komfur/kogeplade",
      "repair_stove_cooktop_oven": "Reparation af komfur/kogeplade/ovn",
      "repair_washer": "Reparation vaskemaskine",
      "repair_washer_dryer": "Reparation af vaskemaskine/tørretumbler",
      "3d_architectural_rendering": "3D-arkitektonisk visualisering",
      "adaptive_reuse_historical_renovation": "Adaptiv genbrug og historisk renovering",
      "architect_other": "Andet",
      "architectural_designing": "Arkitektonisk design",
      "architectural_engineering": "Arkitektonisk ingeniørarbejde",
      "building_code_analysis_permit_coordination": "Kodeanalyse og tilladelser",
      "consulting": "Konsulenttjenester",
      "home_building_improvement": "Husbyggeri og -renovering",
      "interior_design_architect": "Indretningsdesign",
      "planning_zoning_approval_assistance": "Godkendelse af planlægning og zoneinddeling",
      "project_managing_architect": "Projektstyring",
      "site_master_planning": "Planlægning af byggeplads",
      "assisted_living_housekeeping_and_laundry": "Rengøring og vaskeri",
      "assisted_living_meal_services": "Måltidsservice",
      "assisted_living_memory_care": "Hukommelsespleje",
      "assisted_living_other": "Andet",
      "assisted_living_rehabilitation_services": "Rehabiliteringstjenester",
      "assisted_living_transportation": "Transport",
      "assisted_living_wellness_programs": "Wellnessprogrammer",
      "daily_living_assistance": "Hjælp til dagligdagen",
      "medication_management": "Håndtering af medicin",
      "short_term_stays": "Korttidsophold",
      "social_and_recreational_activities": "Fritidsaktiviteter",
      "babysitter_other": "Andet",
      "event_babysitting": "Børnepasning til arrangementer",
      "homework_assistance": "Lektiehjælp",
      "housekeeping_laundry": "Rengøring og vaskeri",
      "meal_preparation": "Madlavning",
      "nanny_services": "Børnepasning",
      "overnight_babysitting": "Børnepasning natten over",
      "pick_up_and_drop_off": "Afhentning og aflevering",
      "shopping_errand": "Shopping og ærinder",
      "special_needs_care": "Pleje af særlige behov",
      "virtual_babysitting": "Virtuel babysitting",
      "agriculture_bankruptcy": "Konkurs i landbruget",
      "bankruptcy_lawyer_other": "Andet",
      "bankruptcy_litigation": "Konkursretssager",
      "chapter_11_bankruptcy": "Kapitel 11 Konkurs",
      "chapter_13_bankruptcy": "Kapitel 13 Konkurs",
      "chapter_7_bankruptcy": "Kapitel 7 Konkurs",
      "corporate_bankruptcy": "Virksomhedskonkurs",
      "creditor_harassment": "Kreditorchikane",
      "debt_settlement": "Gældsafvikling",
      "foreclosure_bankruptcy_lawyer": "Tvangsauktion",
      "personal_bankruptcy": "Personlig konkurs",
      "repossession": "Tilbagetagelse",
      "wage_garnishment": "Lønudlæg",
      "beauty_school_barbering": "Barbering",
      "beauty_school_business_management": "Virksomhedsledelse",
      "beauty_school_cosmetology": "Kosmetologi",
      "beauty_school_esthetics": "Æstetik",
      "beauty_school_hair_cutting": "Hårklipning",
      "beauty_school_hair_design": "Hårdesign",
      "beauty_school_makeup": "Makeup",
      "beauty_school_massage_therapy": "Massageterapi",
      "beauty_school_nail_technology": "Negleteknologi",
      "beauty_school_other": "Andet",
      "beauty_school_retail_training": "Uddannelse i detailhandel",
      "banking_finance_law": "Bank og finansiering",
      "business_lawyer_other": "Andet",
      "business_licenses_permits": "Virksomhedslicenser og -tilladelser",
      "business_litigation": "Erhvervsretssager",
      "business_taxes": "Virksomhedsskat",
      "business_transactions_business_lawyer": "Forretningstransaktioner",
      "commercial_bankruptcy": "Erhvervskonkurs",
      "commercial_contracts_business_lawyer": "Kommercielle kontrakter",
      "employment_law_business_lawyer": "Arbejdsret",
      "incorporation_restructuring": "Selskabsdannelse og omstrukturering",
      "insurance_law": "Forsikringsret",
      "intellectual_property_law": "Intellektuel ejendomsret",
      "mergers_acquisitions_business_lawyer": "Fusioner og opkøb",
      "partnership_agreements_business_lawyer": "Partnerskabsaftaler",
      "patents_copyrights_trademarks": "Patenter, ophavsret og varemærker",
      "securities_law": "Værdipapirlovgivning",
      "shareholder_disputes": "Tvister mellem aktionærer",
      "air_and_cabin_filter": "Luft- og kabinefilter",
      "battery": "Batteri",
      "body_and_trim": "Karrosseri og udstyr",
      "brakes": "Bremser",
      "car_air_conditioning": "Aircondition",
      "car_electrical": "Elektrisk",
      "car_repair_other": "Andet",
      "check_engine_light_diagnostic": "Diagnosticering af motorlys",
      "exhaust": "Udstødning",
      "oil_change": "Olieskift",
      "steering_suspension": "Styretøj/affjedring",
      "tires": "Dæk",
      "transmission": "Gearkasse",
      "cabinetry": "Snedkerarbejde",
      "carpenter_other": "Andet",
      "decking": "Terrasse",
      "drywalling": "Gipsvægge",
      "fencing": "Indhegning",
      "general_installations": "Generelle installationer",
      "general_repairs_maintenance": "Generelle reparationer og vedligeholdelse",
      "remodeling": "Ombygning",
      "shelving_storage": "Hylder og opbevaring",
      "carpet_cleaning_other": "Andet",
      "clean_area_rugs": "Tæpperensning",
      "clean_carpet": "Tæpperensning",
      "clean_drapes_and_curtains": "Rensning af gardiner",
      "clean_upholstery": "Rengøring af polstring",
      "remove_pet_stains_and_odors": "Fjernelse af pletter og lugte fra kæledyr",
      "after_school_care": "SFO",
      "all_hours_daycare": "Døgnåben dagpleje",
      "bilingual_daycare": "Tosproget dagpleje",
      "child_care_other": "Andet",
      "drop_in_daycare": "Drop-in-børnepasning",
      "full_time_daycare": "Fuldtidsdagpleje",
      "in_home_daycare": "Dagpleje i hjemmet",
      "infant_programs": "Spædbørnsprogrammer",
      "part_time_daycare": "Deltidsdagpleje",
      "pre_kindergarten_programs": "Førskoleprogrammer",
      "preschool_programs": "Førskoleprogrammer",
      "school_age_programs": "Programmer for skolebørn",
      "special_needs_daycare": "Specialdagpleje",
      "summer_daycare": "Sommerdagpleje",
      "toddler_programs": "Programmer for småbørn",
      "weekend_daycare": "Weekendbørnepasning",
      "chiropractor_acupuncture": "Akupunktur",
      "chiropractor_chiropractic": "Kiropraktik",
      "chiropractor_massage_therapy": "Massageterapi",
      "chiropractor_other": "Andet",
      "diagnosis": "Diagnose",
      "eastern_medicine": "Østlig medicin",
      "exercise_counseling": "Træningsvejledning",
      "pain_management": "Smertehåndtering",
      "physical_therapy": "Fysioterapi",
      "spinal_adjustments": "Justering af rygsøjlen",
      "sports_medicine": "Idrætsmedicin",
      "cleaner_other": "Andet",
      "deep_clean": "Dybdegående rengøring",
      "moving_clean": "Flytterengøring",
      "office_clean": "Rengøring af kontor",
      "standard_clean": "Normal rengøring",
      "assignment_of_contract": "Overdragelse af kontrakt",
      "business_transactions_contract_lawyer": "Forretningstransaktioner",
      "commercial_contracts_contract_lawyer": "Kommercielle kontrakter",
      "contract_dispute": "Kontraktstrid",
      "contract_lawyer_other": "Andet",
      "contract_negotiation": "Kontraktforhandling",
      "contract_review": "Kontraktgennemgang",
      "employment_contracts_contract_lawyer": "Ansættelseskontrakter",
      "franchise_agreements": "Franchiseaftaler",
      "mergers_acquisitions_contract_lawyer": "Fusioner og opkøb",
      "non_disclosure_agreements_contract_lawyer": "Fortrolighedsaftaler",
      "partnership_agreements_contract_lawyer": "Partnerskabsaftaler",
      "power_of_attorney_contract_lawyer": "Fuldmagt",
      "security_agreements": "Sikkerhedsaftaler",
      "warranties": "Garantier",
      "bathroom_countertops": "Bordplader til badeværelset",
      "bathroom_wall_panels": "Vægpaneler til badeværelset",
      "countertop_design": "Bordpladedesign",
      "countertop_installation": "Montering af bordplade",
      "countertop_pro_other": "Andet",
      "fireplace_facade": "Pejsens facade",
      "granite_countertops": "Granitbordplader",
      "kitchen_countertops": "Køkkenbordplader",
      "kitchen_wall_panels": "Køkkenvægspaneler",
      "laminate_countertops": "Laminatbordplader",
      "marble_countertops": "Marmorbordplader",
      "quartz_countertops": "Kvartsbordplader",
      "remodeling_countertop_pro": "Ombygning",
      "repair_maintenance_countertop_pro": "Reparation og vedligeholdelse",
      "stone_slab_countertops": "Bordplader i sten",
      "tile_countertops": "Flisebordplader",
      "corporate_representation": "Repræsentation af virksomheder",
      "criminal_immigration_defense": "Strafferetlig forsvar i indvandringssager",
      "criminal_lawyer_other": "Andet",
      "domestic_violence": "Vold i hjemmet",
      "drug_possession": "Narkotikabesiddelse",
      "duis_reckless_driving": "Spirituskørsel og hensynsløs kørsel",
      "expungement": "Afskrivning",
      "federal_crimes": "Forbundne forbrydelser",
      "felonies": "Forbrydelser",
      "petty_crimes_misdemeanors": "Småforbrydelser og forseelser",
      "restraining_orders": "Beslaglæggelser",
      "sex_offenses": "Seksuelle overgreb",
      "three_strikes_law": "Three-strikes-lov",
      "dance_instructor_african": "Afrikansk",
      "dance_instructor_ballet": "Ballet",
      "dance_instructor_ballroom": "Ballroom",
      "dance_instructor_belly": "Mave",
      "dance_instructor_bollywood": "Bollywood",
      "dance_instructor_contemporary": "Nutidig",
      "dance_instructor_folk_traditional": "Folkemusik",
      "dance_instructor_hip_hop": "Hiphop",
      "dance_instructor_jazz": "Jazz",
      "dance_instructor_kids_classes": "Børnehold",
      "dance_instructor_latin": "Latin",
      "dance_instructor_modern": "Moderne",
      "dance_instructor_other": "Andet",
      "dance_instructor_tap": "Step",
      "dance_instructor_wedding": "Bryllup",
      "disability_hearings": "Handicaphøringer",
      "disability_lawyer_other": "Andet",
      "long_term_disability": "Langtidsinvaliditet",
      "short_term_disability": "Kortvarig funktionsnedsættelse",
      "social_security_disability_insurance": "Socialsikringsforsikring for invalide",
      "ssa_claim_reconsideration": "Genovervejelse af SSA-krav",
      "ssa_disability_appeals": "SSA-ankesager om invaliditet",
      "ssa_disability_applications": "SSA-handicapansøgninger",
      "ssa_disability_benefits": "SSA-handicapydelser",
      "ssa_family_benefits": "SSA-familieydelser",
      "ssa_impairment_listings": "SSA's lister over funktionsnedsættelser",
      "supplemental_security_income": "Supplerende indkomstsikring",
      "veterans_disability_benefits": "Invaliditetsydelser til veteraner",
      "workers_compensation_disability_lawyer": "Arbejdsskadeerstatning",
      "behind_the_wheel_lessons": "Køreundervisning",
      "commercial_license_training": "Kurser i kommerciel licens",
      "defensive_driving_lessons": "Defensiv køreundervisning",
      "drivers_education_classes": "Kurser i køreundervisning",
      "driving_instructor_other": "Andet",
      "manual_transmission_lessons": "Lektioner i manuel gearskifte",
      "motorcycle_lessons": "Motorcykelundervisning",
      "traffic_school": "Trafikskole",
      "dui_dwi_dui_lawyer": "Spirituskørsel",
      "dui_injuries_dui_lawyer": "Spirituskørsel med skade",
      "dui_lawyer_other": "Andet",
      "dui_with_accident": "Spirituskørsel med ulykke",
      "felony_dui": "Grov spirituskørsel",
      "invalid_tests": "Ugyldige tests",
      "multiple_offenses": "Flere lovovertrædelser",
      "reckless_driving_dui_lawyer": "Uagtsom kørsel",
      "underage_dui": "Spirituskørsel af mindreårig",
      "electric_car_charger": "Installation af elbiloplader",
      "electrician_other": "Andet",
      "electrician_remodeling": "Ombygning",
      "install_fan": "Installation af blæser",
      "install_ground_wire": "Installation af jordledning",
      "install_light_fixtures": "Installation af lysarmaturer",
      "install_outdoor_lighting": "Installation af udendørsbelysning",
      "install_outlets_switches": "Installation af udtag eller kontakter",
      "install_security_system": "Installation af sikkerhedssystem",
      "relocate_outlets_switches": "Flytning af udtag eller kontakter",
      "repair_fan": "Reparation af ventilator",
      "repair_light_fixtures": "Reparation af lysarmaturer",
      "repair_outlets_switches": "Reparation af udtag eller kontakter",
      "repair_panel": "Reparation af panel",
      "replace_upgrade_panel": "Udskift eller opgrader panel",
      "restore_power": "Gendan strøm",
      "energy_efficiency_pro_other": "Andet",
      "charitable_giving": "Velgørenhed",
      "contests_litigation": "Strider/retssager",
      "deeds": "Skøder",
      "estate_lawyer_other": "Andet",
      "estate_planning_lawyer": "Dødsboplanlægning",
      "guardianship_estate_lawyer": "Værgemål",
      "medical_power_of_attorney": "Medicinsk fuldmagt",
      "power_of_attorney_estate_lawyer": "Fuldmagt",
      "probate_estate_lawyer": "Advokat med speciale i dødsboer",
      "trusts": "Forvaltningsformuer",
      "wills": "Testamenter",
      "anniversary_planner": "Årsdag",
      "baby_shower_planner": "Baby shower",
      "bar_and_bat_mitzvah_planner": "Bar og bat mitzvah",
      "birthday_party": "Fødselsdagsfest",
      "children_party": "Børnefest",
      "corporate_and_conference_planner": "Virksomhed og konference",
      "event_planner_other": "Andet",
      "quinceanera_planner": "Quinceanera",
      "religious_event": "Religiøs begivenhed",
      "retirement_party": "Pensionsfest",
      "school_event": "Skolearrangement",
      "theme_party": "Temafest",
      "wedding_and_engagement_planner": "Bryllup og forlovelse",
      "adoption": "Adoption",
      "child_support": "Børnebidrag",
      "contested_divorce": "Omtvistet skilsmisse",
      "debt_division": "Gældsafdeling",
      "family_lawyer_other": "Andet",
      "guardianship_family_lawyer": "Værgemål",
      "mediation_family_lawyer": "Mediation",
      "modifications_of_orders": "Ændring af ordrer",
      "parent_timesharing": "Samværsordning",
      "paternity": "Faderskab",
      "prenuptial_postnuptial_agreements": "Ægtepagter og ægteskabsaftaler",
      "probate_family_lawyer": "Skifteret",
      "property_divisions": "Ejendomsafdeling",
      "protective_orders_domestic_violence_issues": "Beslaglæggelser",
      "spousal_support_alimony": "Ægtefællebidrag og underholdsbidrag",
      "uncontested_divorce": "Ubestridt skilsmisse",
      "custom_construction": "Tilpasset konstruktion",
      "fence_design": "Design af hegn",
      "fencing_other": "Andet",
      "installation_fencing_pro": "Installation af hegn",
      "repairs_maintenance_fencing_pro": "Reparation og vedligeholdelse",
      "education_savings": "Opsparing til uddannelse",
      "estate_financial_planning": "Dødsboplanlægning",
      "financial_planning": "Monetær planlægning",
      "financial_planning_other": "Andet",
      "home_purchase": "Boligkøb",
      "insurance": "Forsikring",
      "investment_advising": "Investeringsrådgivning",
      "retirement_savings": "Pensionering",
      "tax_planning": "Skatteplanlægning",
      "advanced_cardiac_life_support": "Avanceret hjerte-lungeredning",
      "aed_defibrillator": "AED - Hjertestarter",
      "basic_life_support": "Grundlæggende livredning",
      "cpr": "CPR",
      "first_aid": "Førstehjælp",
      "first_aid_trainer_other": "Andet",
      "pediatric_advanced_life_support": "Avanceret livredning til børn",
      "pediatric_cpr_first_aid": "Hjertestopbehandling og førstehjælp til børn",
      "pet_cpr_first_aid": "Hjertestop og førstehjælp til kæledyr",
      "wilderness_first_aid": "Førstehjælp i vildmarken",
      "baseboards": "Fodlister",
      "carpet": "Tæppe",
      "flooring_other": "Andet",
      "hardwood": "Hårdttræ",
      "installation_flooring_pro": "Montering af gulve",
      "marble": "Marmor",
      "polishing": "Polering af gulve",
      "refinishing": "Efterbehandling af gulve",
      "repair_maintenance_flooring_pro": "Reparation og vedligeholdelse af gulve",
      "stair_flooring": "Trappebelægning",
      "tile": "Flise",
      "wood_floor_sanding": "Slibning af trægulve",
      "basement_waterproofing": "Vandtætning af kældre",
      "crawl_spaces": "Krybekælderfundament",
      "foundation_drainage": "Dræning af fundament",
      "foundation_installation": "Installation af fundament",
      "foundation_pro_other": "Andet",
      "foundation_raising": "Forhøjelse af fundament",
      "repairs_maintenance_foundation_pro": "Reparation og vedligeholdelse",
      "slab_foundation": "Pladefundament",
      "steel_pier_pilings": "Stålpæle til moler",
      "water_moisture_control": "Vand- og fugtkontrol",
      "burials": "Begravelser",
      "caskets": "Kister",
      "cremation": "Kremering",
      "funeral_home_flowers": "Blomster",
      "funeral_home_other": "Andet",
      "funeral_home_transportation_transfers": "Transport og transfer",
      "funeral_home_veteran_services": "Veterantjenester",
      "funerals": "Begravelser",
      "gravestones": "Gravsten",
      "grief_services": "Sorgterapi",
      "memorials": "Mindehøjtideligheder",
      "urns": "Urner",
      "garage_door_other": "Andet",
      "general_maintenance": "Generel vedligeholdelse",
      "install_garage_door": "Installer garageport",
      "install_opener": "Installer åbner",
      "repair_cables": "Reparation af kabler",
      "repair_garage_door": "Reparation garageport",
      "repair_gate": "Reparation af låge",
      "repair_rollers_tracks": "Reparation af ruller og skinner",
      "replace_door_panels": "Udskiftning af dørpaneler",
      "replace_opener": "Udskiftning af åbner",
      "replace_springs": "Udskiftning af fjedre",
      "accessory_buildings": "Tilbygninger",
      "bathroom_remodel": "Renovering af badeværelse",
      "decks_patio": "Terrasser og gårdhaver",
      "exterior_finishing": "Udvendig finish",
      "foundations_concrete": "Fundamenter og beton",
      "general_contractor_commercial_projects": "Kommercielle projekter",
      "general_contractor_other": "Andet",
      "home_addition": "Tilbygning til huset",
      "home_building": "Boligbyggeri",
      "home_remodel_renovation": "Renovering og ombygning af boliger",
      "interior_finishing": "Indvendig finish",
      "kitchen_remodel": "Ombygning af køkken",
      "roofing": "Tagdækning",
      "assemble_furniture": "Samling af møbler",
      "clean_gutters": "Rengøring af tagrender",
      "handyman_other": "Andet",
      "install_drywall": "Montering af gipsvægge",
      "install_flooring": "Montering af gulv",
      "install_tile": "Montering af fliser",
      "install_water_fixtures": "Montering af vandarmaturer",
      "mount_tv": "Installation af TV",
      "paint_indoors": "Maling indendørs",
      "paint_outdoors": "Maling udendørs",
      "repair_drywall": "Reparation af gipsvæg",
      "repair_flooring": "Reparation af gulvbelægning",
      "repair_water_fixtures": "Reparation af vandarmaturer",
      "replace_tile": "Udskiftning af fliser",
      "buyer_seller_inspection": "Køber-/sælgerinspektion",
      "commercial_properties": "Kommercielle ejendomme",
      "fire_safety": "Brandsikkerhed",
      "fireplace_chimney": "Pejs og skorsten",
      "full_home_inspection": "Komplet boliginspektion",
      "home_inspector_electrical": "Elektrisk",
      "home_inspector_foundation": "Fundament",
      "home_inspector_hvac": "HVAC",
      "home_inspector_mold": "Skimmelsvamp",
      "home_inspector_new_construction": "Ny konstruktion",
      "home_inspector_other": "Andet",
      "home_inspector_plumbing": "Blikkenslagerarbejde",
      "home_inspector_roof": "Tag",
      "home_inspector_structural": "Strukturel",
      "home_warranty": "Boliggaranti",
      "water_testing": "Vandtest",
      "well_or_septic_system": "Brønd eller septiksystem",
      "wood_insects": "Træ og insekter",
      "access_control": "Adgangskontrol",
      "alarm_systems": "Alarmsystemer",
      "commercial_security_systems": "Kommercielle sikkerhedssystemer",
      "fire_smoke_detection": "Brand- og røgdetektion",
      "home_security_doors": "Døre",
      "home_security_locks": "Låse",
      "home_security_other": "Andet",
      "home_security_windows": "Vinduer",
      "monitoring_services": "Overvågningstjenester",
      "residential_security_systems": "Sikkerhedssystemer til private hjem",
      "smart_home_integration": "Integration af Smart Home",
      "video_surveillance": "Videoovervågning",
      "audio_video_installation": "Audio- og videoinstallation",
      "commercial_projects": "Kommercielle projekter",
      "home_theater_design": "Design af hjemmebiograf",
      "home_theater_lighting": "Belysning",
      "home_theater_other": "Andet",
      "home_theater_smart_home_integration": "Integration af Smart Home",
      "install_tv": "Installation af TV",
      "network_it_services": "Netværks- og IT-tjenester",
      "outdoor_installations": "Udendørsinstallationer",
      "soundproofing": "Lydisolering",
      "whole_house_audio_video": "Audio-video i hele huset",
      "ac_maintenance": "Vedligeholdelse af klimaanlæg",
      "clean_ducts_vents": "Rengøring af kanaler og ventilationsåbninger",
      "ductless_heating_and_ac_services": "Kanalfri varme- og klimaanlægstjenester",
      "heating_maintenance": "Vedligeholdelse af varmeanlæg",
      "hvac_maintenance": "Vedligeholdelse af HVAC-anlæg",
      "hvac_other": "Andet",
      "install_ac": "Installation af klimaanlæg",
      "install_ducts_vents": "Installation af kanaler og ventilationsåbninger",
      "install_heating_system": "Installation af varmesystem",
      "install_thermostat": "Installation af termostat",
      "repair_ac": "Reparation af klimaanlæg",
      "repair_ducts_vents": "Reparation af kanaler og ventilationsåbninger",
      "repair_heating_system": "Reparation af varmesystem",
      "repair_hvac": "Reparation af HVAC",
      "repair_thermostat": "Reparation af termostat",
      "asylum": "Asyl",
      "citizenship": "Medborgerskab",
      "deportation": "Udvisning",
      "family_based_immigration": "Familiebaseret immigration",
      "green_card": "Green Card",
      "immigration_lawyer_other": "Andet",
      "investment_visa": "Investeringsvisum",
      "outbound_work_permits": "Udgående arbejdstilladelser",
      "student_visa": "Studievisum",
      "visitor_visa": "Besøgsvisum",
      "work_visa": "Arbejdsvisum",
      "appliance_selection": "Valg af apparater",
      "cabinetry_molding_hardware_design": "Design af skabe og beslag",
      "decorating": "Dekoration",
      "door_design": "Dørdesign",
      "exterior_building_design": "Udvendigt bygningsdesign",
      "flooring_selection": "Valg af gulvbelægning",
      "interior_designer_other": "Andet",
      "landscaping_design": "Landskabsdesign",
      "lighting_design": "Belysningsdesign",
      "multifamily_housing_design": "Design af flerfamiliehuse",
      "room_planning": "Rumplanlægning",
      "stone_brick_stucco_design": "Design med sten, mursten og puds",
      "window_design": "Vinduesdesign",
      "advertisements": "Annoncer",
      "copyright": "Ophavsret",
      "export_control": "Eksportkontrol",
      "franchises": "Franchises",
      "international_ip": "International IP-adresse",
      "ip_lawyer_other": "Andet",
      "ip_strategy": "IP-strategi",
      "ip_transactions": "IP-transaktioner",
      "licensing": "Licens",
      "litigation_ip_lawyer": "Retssager",
      "non_disclosure_agreements_ip_lawyer": "Fortrolighedsaftaler",
      "patents": "Patenter",
      "technology_transfer": "Teknologioverførsel",
      "trade_secrets": "Forretningshemmeligheder",
      "trademarks": "Varemærker",
      "appliance_removal": "Fjernelse af apparat",
      "construction_waste_removal": "Bortskaffelse af byggeaffald",
      "donation_pickup": "Afhentning af donation",
      "electronic_waste_removal": "Bortskaffelse af elektronisk affald",
      "furniture_removal": "Flytning af møbler",
      "general_junk_removal": "Generel fjernelse af skrot",
      "hazardous_waste_removal": "Bortskaffelse af farligt affald",
      "house_garage_cleanout": "Rydning af hus/garage",
      "junk_removal_other": "Andet",
      "yard_waste_removal": "Bortskaffelse af haveaffald",
      "employment_contracts_labor_lawyer": "Ansættelseskontrakter",
      "employment_law_labor_lawyer": "Ansættelseslovgivning",
      "exempt_employee_status": "Status som fritaget medarbejder",
      "labor_law": "Arbejdsret",
      "labor_lawyer_other": "Andet",
      "labor_negotiations": "Lønforhandlinger",
      "privacy_rights": "Ret til privatlivets fred",
      "sexual_harassment": "Seksuel chikane",
      "unpaid_overtime": "Ubetalt overarbejde",
      "whistle_blowing": "Whistleblowing",
      "workers_compensation_labor_lawyer": "Arbejdsskadeerstatning",
      "wrongful_termination": "Uretmæssig opsigelse",
      "artificial_turf_installation": "Montering af kunstgræs",
      "concrete_masonry": "Betonmurværk",
      "driveway_landscaping": "Indkørselsarkitektur",
      "garden_decorations": "Dekorationer til haven",
      "grading_resloping": "Planering og omlægning",
      "hardscapes": "Hardscapes",
      "landscape_design": "Landskabsdesign",
      "landscape_installations": "Landskabsdesign",
      "landscaper_other": "Andet",
      "outdoor_steps": "Udendørs trin",
      "outdoor_water_feature": "Udendørs vandfunktioner",
      "paving_driveway_walkway": "Belægning af indkørsel eller gangsti",
      "retaining_walls": "Støttemure",
      "sidewalk_walkway_landscaping": "Landskabspleje af gangstier",
      "sod_seeding": "Græs og såning",
      "stone_masonry": "Stenmurværk",
      "arabic": "Arabisk",
      "english": "Engelsk",
      "french": "Fransk",
      "german": "Tysk",
      "hebrew": "Hebraisk",
      "italian": "Italiensk",
      "japanese": "Japansk",
      "korean": "Koreansk",
      "language_instructor_other": "Andet",
      "mandarin": "Mandarin",
      "portuguese": "Portugisisk",
      "russian": "Russisk",
      "sign_language": "Tegnsprog",
      "spanish": "Spanish",
      "irrigation_system_repair_maintenance": "Reparation/vedligeholdelse af kunstvandingssystem",
      "lawn_care_other": "Andet",
      "lawn_mowing_maintenance": "Plæneklipning/-vedligeholdelse",
      "lawn_pest_control": "Bekæmpelse af skadedyr i plænen",
      "mulching": "Tildækning af muld",
      "seeding": "Såning",
      "sod_installation": "Udrulning af rullegræs",
      "weed_control": "Bekæmpelse af ukrudt",
      "yard_cleanup": "Oprydning af haven",
      "appeals": "Appeller",
      "case_assessment_litigation_lawyer": "Sagsvurdering",
      "civil_litigation": "Civil retssag",
      "commercial_litigation": "Kommerciel retssag",
      "contracts_and_agreements": "Kontrakter og aftaler",
      "criminal_litigation": "Kriminel retssag",
      "litigation_lawyer_other": "Andet",
      "mediation_litigation_lawyer": "Mediation",
      "settlements": "Afregninger",
      "building_lockout": "Bygningslockout",
      "copy_building_key": "Kopiér bygningsnøgler",
      "copy_vehicle_key": "Kopiér bilnøgle",
      "install_hardware": "Installer hardware",
      "locksmith_other": "Andet",
      "new_key_fob": "Ny nøglebrik",
      "rekey_lock": "Udskiftning af lås",
      "repair_hardware": "Reparation af hardware",
      "vehicle_lockout": "Låst ude af bilen",
      "consent_issues": "Samtykkeproblematikker",
      "diagnosis_errors": "Diagnosefejl",
      "malpractice_lawyer_other": "Andet",
      "medical_negligence": "Medicinsk uagtsomhed",
      "treatment_errors": "Fejl i behandlingen",
      "massage_center_other": "Andet",
      "massage_school_advanced_neuromuscular_therapy": "Avanceret neuromuskulær terapi",
      "massage_school_business_and_ethics": "Erhverv og etik",
      "massage_school_clinical_therapies": "Kliniske behandlinger",
      "massage_school_continuing_education": "Efteruddannelse",
      "massage_school_deep_tissue_massage": "Dyb vævsmassage",
      "massage_school_energetics": "Energetik",
      "massage_school_hydrotherapy": "Hydroterapi",
      "massage_school_lymphatic_massage": "Lymfemassage",
      "massage_school_online_massage_therapy": "Onlinemassageterapi",
      "massage_school_other": "Andet",
      "massage_school_prenatal_massage": "Graviditetsmassage",
      "massage_school_sports_massage": "Sportsmassage",
      "massage_school_student_massage_clinic": "Klinik for massagestuderende",
      "massage_school_swedish_massage": "Svensk massage",
      "massage_theory": "Massageteori",
      "massage_therapy_training": "Kurser i massageterapi",
      "in_state_move": "Flytning inden for staten",
      "local_move": "Lokal flytning",
      "mover_other": "Andet",
      "moving_junk_removal": "Fjernelse af affald",
      "moving_storage": "Opbevaring",
      "out_of_state_move": "Flytning uden for staten",
      "oversized_item_move": "Flytning af overdimensioneret genstand",
      "packing_unpacking": "Pakning/udpakning",
      "senior_move": "Seniorflytning",
      "vehicle_transport": "Transport af køretøjer",
      "cardiac_care": "Hjertebehandling",
      "general_medical_care": "Almen lægehjælp",
      "hospice": "Hospice",
      "iv_therapy": "IV-behandling",
      "nursing_home_meal_services": "Måltidsservice",
      "nursing_home_memory_care": "Hukommelsespleje",
      "nursing_home_other": "Andet",
      "nursing_home_pain_management": "Smertehåndtering",
      "nursing_home_rehabilitation_services": "Rehabiliteringstjenester",
      "nursing_home_wellness_programs": "Wellness-programmer",
      "outpatient_rehabilitation": "Ambulant rehabilitering",
      "post_hospital_care": "Pleje efter hospitalsindlæggelse",
      "respiratory_and_pulmonary_care": "Åndedræts- og lungepleje",
      "senior_activity_programs": "Aktivitetsprogrammer for seniorer",
      "short_term_rehabilitation": "Korttidsrehabilitering",
      "wound_care": "Sårpleje",
      "exterior_painting": "Udvendigt malerarbejde",
      "interior_painting": "Indvendigt malerarbejde",
      "paint_cabinets": "Maling af skabe",
      "paint_doors": "Maling af døre",
      "painter_other": "Andet",
      "repair_water_damage": "Udbedring af vandskade",
      "staining": "Farvning",
      "assault_battery": "Overfald og vold",
      "auto_accidents": "Bilulykker",
      "bicycle_accidents": "Cykelulykker",
      "catastrophic_injuries": "Katastrofale skader",
      "dog_bites": "Hundebid",
      "dui_injuries_personal_injury_lawyer": "Skader fra spirituskørsel",
      "medical_malpractice": "Lægefejl",
      "motorcycle_accidents": "Motorcykelulykker",
      "pain_suffering": "Smerte og lidelse",
      "pedestrian_accidents": "Fodgængerulykker",
      "personal_injury_lawyer_other": "Andet",
      "product_liability": "Produktansvar",
      "slip_fall": "Glid og fald",
      "uninsured_motorist_claims": "Krav til bilforsikring",
      "workers_compensation_personal_injury_lawyer": "Arbejdsskadeerstatning",
      "wrongful_death": "Uretmæssig død",
      "aerobics": "Aerobic",
      "athletic_performance": "Atletisk præstation",
      "circuit_training": "Kredsløbstræning",
      "endurance": "Udholdenhed",
      "fitness_assessment": "Vurdering af egnethed",
      "hiit": "HIIT",
      "nutritional_counseling": "Ernæringsrådgivning",
      "personal_trainer_other": "Andet",
      "strength_conditioning": "Styrke og kondition",
      "weight_loss": "Vægttab",
      "yoga": "Yoga",
      "ants": "Myrer",
      "bed_bugs": "Væggelus",
      "bees": "Bier",
      "cockroaches": "Kakerlakker",
      "fleas_or_mites": "Lopper eller mider",
      "hornets_or_wasps": "Gedehamse eller hvepse",
      "mosquitoes": "Myg",
      "pest_control_other": "Andet",
      "pest_inspection": "Inspektion",
      "rodents": "Gnavere",
      "spiders": "Edderkopper",
      "termites": "Termitter",
      "wildlife": "Dyreliv",
      "pet_adoption_birds": "Fugle",
      "pet_adoption_cats": "Katte",
      "pet_adoption_dogs": "Hunde",
      "pet_adoption_farm_animals": "Landbrugsdyr",
      "pet_adoption_fish": "Fisk",
      "pet_adoption_other": "Andet",
      "pet_adoption_reptiles": "Reptiler",
      "pet_adoption_small_mammals": "Små pattedyr",
      "pet_adoption_special_needs_animals": "Dyr med særlige behov",
      "cat_boarding": "Kattepension",
      "cat_grooming": "Kattepleje",
      "cat_sitting_in_home": "Kattepasning (i hjemmet)",
      "dog_boarding": "Hundepension",
      "dog_boarding_with_training": "Hundepension med kurser",
      "dog_daycare": "Dagpleje for hunde",
      "dog_grooming": "Hundesalon",
      "dog_sitting_in_home": "Hundepasning (i hjemmet)",
      "dog_training": "Hundetræning",
      "dog_walking": "Hundeluftning",
      "other_pet_boarding": "Pension til andre kæledyr",
      "other_pet_daycare": "Andet dyrepasning",
      "other_pet_grooming": "Andet kæledyrspleje",
      "other_pet_sitting_in_home": "Andet kæledyrspasning (i hjemmet)",
      "pet_boarding_other": "Andet",
      "cat_bathing": "Kattevask",
      "cat_ear_cleaning": "Rensning af katteører",
      "cat_grooming_and_styling": "Kattepleje og styling",
      "cat_nail_trimming": "Negleklipning til katte",
      "dog_anal_gland_expression": "Analkirteludtryk på hunde",
      "dog_bathing_and_blow_dry": "Hundevask og føntørring",
      "dog_ear_cleaning": "Rensning af hundeører",
      "dog_flea_and_tick_treatment": "Behandling af lopper og flåter hos hunde",
      "dog_full_service_grooming": "Hundepleje med fuld service",
      "dog_grooming_and_styling": "Hundepleje og styling",
      "dog_nail_trimming": "Klipning af hundens negle",
      "dog_teeth_brushing": "Rensning af hundetænder",
      "pet_grooming_other": "Andet",
      "aggressive_dog_training": "Træning af aggressive hunde",
      "behavior_modification": "Adfærdsændring",
      "obedience_training": "Lydighedstræning",
      "offleash_training": "Træning uden snor",
      "pet_trainer_other": "Andet",
      "puppy_training": "Hvalpetræning",
      "service_animal_training": "Træning af servicedyr",
      "sport_trick_training": "Sport- eller tricktræning",
      "training_other_animals": "Træning for andre dyr",
      "corporate_photo": "Virksomhed",
      "events_and_parties_photo": "Begivenheder og fester",
      "family_and_group_photo": "Familie og gruppe",
      "headshots_and_portraits": "Portrætbilleder",
      "individual_photo": "Individuel",
      "maternity_and_newborn_photo": "Moderskab og nyfødte",
      "photographer_other": "Andet",
      "product_photo": "Produkt",
      "real_estate_photo": "Fast ejendom",
      "school_portraits": "Skoleportrætter",
      "wedding_and_engagement_photo": "Bryllup og forlovelse",
      "find_leak": "Find og reparer læk",
      "install_faucet": "Installation af vandhane",
      "install_garbage_disposal": "Installation af affaldsdispenser",
      "install_shower": "Installation af bruser",
      "install_toilet": "Installation af toilet",
      "install_water_heater": "Installation af vandvarmer",
      "plumbing_other": "Andet",
      "repair_faucet": "Reparation vandhane",
      "repair_garbage_disposal": "Reparation af affaldskværn",
      "repair_outdoor_systems": "Reparation af udendørssystemer",
      "repair_pipe": "Reparation af rør",
      "repair_sewer": "Reparation af kloaksystem",
      "repair_shower": "Reparation af bruser",
      "repair_toilet": "Reparation af toilet",
      "repair_water_heater": "Reparation af varmtvandsbeholder",
      "unclog_drain": "Fjern tilstopning af afløb",
      "commercial_pool_cleaning_maintenance": "Rengøring og vedligeholdelse af kommercielle pools",
      "equipment_maintenance_repair": "Vedligeholdelse og reparation af udstyr",
      "one_time_pool_cleaning": "Engangsrengøring af pool",
      "ongoing_pool_cleaning": "Løbende rengøring af pool",
      "pool_cleaner_other": "Andet",
      "pool_cleaner_water_features": "Vandfunktioner",
      "seasonal_opening_closing": "Sæsonbestemt åbning og lukning",
      "spa_hot_tub_cleaning": "Rengøring af spa og boblebad",
      "spa_hot_tub_repairs": "Reparation af spa og boblebad",
      "tile_pool_wall_cleaning": "Rengøring af fliser og poolvæg",
      "water_testing_balancing": "Vandprøvning og afbalancering",
      "jetted_lap_pools": "Bassiner med boblebad",
      "pool_construction": "Opførelse af pool",
      "pool_contractor_commercial_projects": "Kommercielle projekter",
      "pool_contractor_custom_designs": "Tilpassede designs",
      "pool_contractor_other": "Andet",
      "pool_contractor_renovation": "Renovering",
      "pool_contractor_repair_cracks": "Reparation af revner",
      "pool_contractor_repair_tile": "Reparation af fliser",
      "pool_contractor_resurfacing": "Nybelæning",
      "pool_contractor_water_features": "Vandfunktioner",
      "pool_hot_tub_equipment": "Udstyr til pool og boblebad",
      "spa_hot_tub_installation": "Installation af spa og boblebad",
      "bilingual_programs": "Tosprogede programmer",
      "early_preschool": "Tidlig børnehave",
      "full_day_preschool": "Heldagsbørnehave",
      "half_day_preschool": "Halvdagsbørnehave",
      "kindergarten_classes": "Børnehaveklasser",
      "montessori_programs": "Montessori-programmer",
      "play_based_preschool": "Legebaseret børnehave",
      "preschool_infant_programs": "Spædbørnsprogrammer",
      "preschool_other": "Andet",
      "reggio_emilia_preschool": "Reggio Emilia-børnehave",
      "special_needs_programs": "Programmer for særlige behov",
      "summer_camp": "Sommerlejr",
      "waldorf_preschool": "Waldorf-børnehave",
      "psychologist_other": "Andet",
      "buyer_agent": "Købers agent",
      "first_time_home_buyer": "Førstegangskøber",
      "foreclosed_properties": "Tvangsauktionsejendomme",
      "luxury_properties": "Luksusejendomme",
      "new_construction": "Nybyggeri",
      "property_management": "Ejendomsadministration",
      "real_estate_agent_other": "Andet",
      "relocation": "Flytning",
      "rentals": "Udlejning",
      "sellers_agent": "Sælgers agent",
      "commercial_real_estate": "Erhvervsejendomme",
      "easements": "Servitutter",
      "encroachment": "Overgreb",
      "foreclosure_real_esate_lawyer": "Tvangsauktion",
      "landlord_tenant_law": "Udlejer- og lejeret",
      "litigation_real_estate_lawyer": "Retssager",
      "mortgage_lending_law": "Realkredit- og långivningslovgivning",
      "neighbor_hoa_disputes": "Tvister med naboer og boligforeninger",
      "property_damage": "Skader på ejendom",
      "purchase_agreements": "Købsaftaler",
      "real_estate_contracts_transactions": "Ejendomstransaktioner",
      "real_estate_lawyer_other": "Andet",
      "residential_real_estate": "Boligejendom",
      "title_services": "Titeltjenester",
      "trespassing": "Ulovlig indtrængen",
      "rehab_other": "Andet",
      "attic_venting": "Loftsventilation",
      "gutter_installation": "Montering af tagrender",
      "gutter_repair": "Reparation af tagrender",
      "roof_inspection": "Taginspektion",
      "roof_installation": "Montering af tag",
      "roof_repair": "Tagreparation",
      "roofer_other": "Andet",
      "skylight_installation": "Montering af ovenlysvindue",
      "skylight_repair": "Reparation af ovenlysvindue",
      "storm_wind_damage_roof_repair": "Reparation af tagskader",
      "sewage_cleaning": "Rensning",
      "sewage_excavation": "Udgravning",
      "sewage_inspection": "Inspektion",
      "sewage_installation": "Installation",
      "sewage_locating": "Lokalisering",
      "sewage_maintenance_repairs": "Vedligeholdelse og reparationer",
      "sewage_pro_other": "Andet",
      "sewage_pumping": "Pumpning",
      "sewage_removal_demolition": "Fjernelse eller nedrivning",
      "remodeling_siding_pro": "Ombygning",
      "repair_maintenance_siding_pro": "Reparation og vedligeholdelse",
      "siding_installation": "Montering af facadebeklædning",
      "siding_pro_other": "Andet",
      "siding_removal": "Fjernelse af beklædning",
      "smart_home_other": "Andet",
      "commercial_snow_removal": "Kommerciel snerydning",
      "residential_plowing": "Snerydning for private boliger",
      "residential_shoveling_blowing": "Snerydning og sneskovling for private boliger",
      "salt_sand_deicing": "Salt, sand og afisning",
      "snow_relocation": "Sneflytning",
      "snow_removal_other": "Andet",
      "body_polish": "Bodyscrub",
      "body_wrap": "Bodywrap",
      "facial": "Facial",
      "hydrotherapy": "Hydroterapi",
      "manicure": "Manicure",
      "massage": "Massage",
      "pedicure": "Pedicure",
      "peels": "Peels",
      "spa_other": "Andet",
      "spa_packages": "Spa-pakker",
      "tanning": "Solbruning",
      "waxing": "Voksning",
      "civil_tax_litigation": "Civil skatteretssag",
      "corporate_taxes": "Virksomhedsskat",
      "criminal_tax_litigation": "Strafferetlig skattesag",
      "estate_tax_planning": "Planlægning af boafgift",
      "failure_to_file": "Manglende indgivelse",
      "innocent_spouse_relief": "Hjælp til uskyldig ægtefælle",
      "international_tax_services": "Internationale skatteydelser",
      "irs_tax_problems": "Problemer med IRS-skat",
      "non_collectible_status": "Ikke-opkrævbar status",
      "offer_in_compromise": "Kompromistilbud",
      "tax_audits": "Skatterevision",
      "tax_lawyer_other": "Andet",
      "tax_liens_levies": "Skattelettelser og -opkrævninger",
      "tax_planning_lawyer": "Skatteplanlægning",
      "tax_relief": "Skattefritagelse",
      "accounting_support": "Bogføringssupport",
      "business_incorporation_restructuring": "Inkorporering og omstrukturering",
      "cryptocurrency_taxes": "Skatter på kryptovaluta",
      "irs_audit_representation": "Repræsentation ved IRS-revision",
      "irs_filing": "Indsendelse til IRS",
      "irs_problem_consulting": "Rådgivning om IRS-problemer",
      "new_business_services": "Nye forretningstjenester",
      "payroll_support": "Lønsupport",
      "tax_planning_tax_specialist": "Skatteplanlægning",
      "tax_preparation": "Skatteforberedelse",
      "tax_problem_consulting_tax_specialist": "Rådgivning om skatteproblemer",
      "tax_specialist_other": "Andet",
      "therapist_other": "Andet",
      "battery_service": "Batteriservice",
      "car_towing": "Bugsering af bil",
      "fuel_delivery": "Levering af brændstof",
      "local_hauling": "Lokal transport",
      "long_distance_hauling": "Langdistancefragt",
      "motorcycle_towing": "Bugsering af motorcykler",
      "special_vehicle_towing": "Bugsering af specialkøretøjer",
      "tire_change": "Dækskift",
      "towing_other": "Andet",
      "case_assessment_traffic_lawyer": "Sagsvurdering",
      "cdl_traffic_ticket": "Trafikforseelse ved erhvervskørekort",
      "dui_dwi_traffic_lawyer": "Spirituskørsel",
      "fixit_ticket": "Bøde for en mindre overtrædelse i forbindelse med køretøjer",
      "parking_ticket": "Parkeringsbøde",
      "reckless_driving_traffic_lawyer": "Uagtsom kørsel",
      "red_light_ticket": "Bøde for rødt lys",
      "speeding_ticket": "Fartbøde",
      "suspended_license": "Inddraget kørekort",
      "traffic_lawyer_other": "Andet",
      "traffic_ticket": "Færdselsbøde",
      "cabling_and_bracing": "Kabelføring og afstivning",
      "stump_removal": "Fjernelse af stub",
      "tree_planting": "Plantning af træer",
      "tree_removal": "Træfældning",
      "tree_service_other": "Andet",
      "tree_transplanting": "Transplantation af træer",
      "tree_trimming_and_pruning": "Beskæring og trimning af træer",
      "tutor_computer_science": "Datalogi",
      "tutor_foreign_languages": "Fremmedsprog",
      "tutor_geography": "Geografi",
      "tutor_government_and_economics": "Regering og økonomi",
      "tutor_history": "Historie",
      "tutor_homework_help": "Lektiehjælp",
      "tutor_math": "Matematik",
      "tutor_other": "Andet",
      "tutor_reading_and_writing": "Læsning og skrivning",
      "tutor_science": "Videnskab",
      "tutor_special_education": "Specialuddannelse",
      "tutor_test_pre_college_entrance": "Forberedelse til eksamen: optagelse på universitetet",
      "tutor_test_prep_grad_school_entrance": "Forberedelse til eksamen: optagelse på videregående uddannelser",
      "tutor_test_prep_k8": "Forberedelse til eksamen: K-8",
      "area_rug_cleaning": "Tæpperens",
      "drapery_and_blind_cleaning": "Rens af gardiner og persienner",
      "leather_cleaning": "Læderrens",
      "mattress_cleaning": "Madrasrens",
      "upholstery_cleaner_other": "Andet",
      "upholstery_cleaning": "Rengøring af møbelbetræk",
      "upholstery_water_damage_cleanup": "Oprydning efter vandskade",
      "bird_exotic_animal_care": "Pasning af fugle og eksotiske dyr",
      "farm_barn_animal_care": "Pasning af dyr på gården og i stalden",
      "microchipping": "Mikrochipning",
      "veterinarian_allergies": "Allergier",
      "veterinarian_behavior_counseling": "Adfærdsrådgivning",
      "veterinarian_dental_care": "Tandpleje",
      "veterinarian_dermatology": "Dermatologi",
      "veterinarian_emergency_care": "Akutbehandling",
      "veterinarian_end_of_life_care": "Pleje ved livets afslutning",
      "veterinarian_examinations": "Undersøgelser",
      "veterinarian_nutrition_counseling": "Ernæringsrådgivning",
      "veterinarian_other": "Andet",
      "veterinarian_preventive_care": "Forebyggende vedligeholdelse",
      "veterinarian_spay_neuter": "Sterilisering eller kastrering",
      "veterinarian_surgery": "Kirurgi",
      "veterinarian_vaccinations": "Vaccinationer",
      "aerial_videography": "Luftfotografering",
      "documentary_video_production": "Dokumentarproduktion",
      "family_video_production": "Produktion af familievideoer",
      "live_streaming": "Livestreaming",
      "photography": "Fotografi",
      "product_demonstrations": "Produktdemonstration",
      "promotional_video_production": "Produktion af reklamevideoer",
      "real_estate_video_production": "Videoproduktion til Ejendomsbranchen",
      "special_event_video_production": "Videoproduktion til særlige begivenheder",
      "video_editing": "Videoredigering",
      "videographer_other": "Andet",
      "voice_overs": "Voiceover",
      "wedding_video_production": "Produktion af bryllupsvideoer",
      "fire_damage_cleanup_repair": "Oprydning/reparation af brandskader",
      "water_damage_cleanup_repair": "Oprydning efter vandskade",
      "water_damage_flooring": "Gulvbelægning",
      "water_damage_mold_inspection": "Inspektion af skimmelsvamp",
      "water_damage_mold_removal": "Fjernelse af skimmelsvamp",
      "water_damage_other": "Andet",
      "water_damage_painting": "Maleri",
      "water_damage_pest_control": "Skadedyrsbekæmpelse",
      "water_damage_plumbing": "Blikkenslagerarbejde",
      "water_damage_remodeling": "Ombygning",
      "water_damage_roofing": "Tagdækning",
      "water_damage_sewage_cleanup": "Oprydning af spildevand",
      "adult_weight_loss_programs": "Vægttabsprogrammer for voksne",
      "diet_and_nutrition_counseling": "Rådgivning om kost- og ernæring",
      "kids_weight_loss_programs": "Vægttabsprogrammer for børn",
      "metabolic_testing": "Metabolisk test",
      "weight_loss_consultation_and_training": "Konsultation og kurser",
      "weight_loss_fitness_programs": "Fitnessprogrammer",
      "weight_loss_meal_planning": "Måltidsplanlægning",
      "weight_loss_personal_training": "Personlig træning",
      "weight_loss_service_other": "Andet",
      "weight_loss_wellness_programs": "Wellness-programmer",
      "glass_and_mirror_cleaning": "Rengøring af glas og spejle",
      "gutter_cleaning": "Rensning af tagrender",
      "power_pressure_washing": "Kraft-/højtryksvask",
      "rooftop_skylight_cleaning": "Vask af tagterrasse/ovenlysvindue",
      "window_cleaner_other": "Andet",
      "window_cleaning": "Vinduespudsning",
      "door_installation": "Dørinstallation",
      "door_repair": "Dørreparation",
      "glass_installation": "Glasinstallation",
      "window_boardup": "Boardup",
      "window_installation": "Montering af vinduer",
      "window_repair": "Reparation af vinduer",
      "window_repair_other": "Andet",
      "install_new_wiper_blades": "Montering af nye viskerblade",
      "repair_power_window": "Reparation af elrude",
      "repair_water_leak": "Udbedring af vandlækage",
      "repair_windshield": "Reparation af forrude",
      "replace_rear_window": "Udskiftning af bagrude",
      "replace_side_view_mirrors": "Reparation af sidespejle",
      "replace_side_window": "Udskiftning af sidespejle",
      "replace_sunroof": "Udskiftning af soltag",
      "replace_windshield": "Udskiftning af forrude",
      "windshield_other": "Andet",
      "ashtanga": "Ashtanga",
      "hatha": "Hatha",
      "hot_yoga": "Hot yoga",
      "iyengar": "Iyengar",
      "kundalini": "Kundalini",
      "meditation": "Meditation",
      "power_yoga": "Poweryoga",
      "restorative": "Genopbyggende",
      "vinyasa": "Vinyasa",
      "yin": "Yin",
      "yoga_instructor_other": "Andet"
    }
  }
}